{
  "en": {
    "Загрузите запись или видео": "Upload a recording or video",
    "Разговор, интервью, лекция или голосовое": "A conversation, interview, lecture or voice message",
    "Загрузите фото товара": "Upload a product photo",
    "Необязательно: по фото опишем детали точнее": "Optional: photos help us describe the details more precisely",
    "По фото найдём материал, цвет и детали": "We’ll find the material, colour and details in the photos",
    "Опишем снимок так, чтобы его можно было повторить": "We’ll describe the shot so it can be recreated",
    "Опишем сцену, движение камеры и свет": "We’ll describe the scene, the camera movement and the light",
    "Вставить": "Paste",
    "Это не ссылка на ролик YouTube": "This is not a link to a YouTube video",
    "Ссылка на YouTube": "YouTube link",
    "Или ссылка на YouTube": "Or a YouTube link",
    "Ссылка на ролик YouTube": "Link to a YouTube video",
    "Весь текст": "Full text",
    "С временем абзацев": "With paragraph times",
    "Пересказ": "Summary",
    "Главное в нескольких абзацах": "The main points in a few paragraphs",
    "Тезисы": "Key points",
    "Коротко по пунктам": "Briefly, point by point",
    "Язык текста": "Text language",
    "Исходный": "Original",
    "Подписать собеседников": "Label the speakers",
    "Без имён": "No names",
    "Время реплик": "Line times",
    "В начале каждой реплики": "At the start of every line",
    "Без времени": "No times",
    "Время в начале каждой реплики": "Time at the start of every line",
    "Я.Маркет": "Y.Market",
    "Общая для товарных инструментов": "Shared by the product tools",
    "Только для описания": "For the description only",
    "Например: коротко, простыми словами": "For example: briefly, in simple words",
    "Стиль промпта": "Prompt style",
    "Одна-две фразы": "One or two sentences",
    "Сцена, свет, камера, стиль": "Scene, light, camera, style",
    "По пунктам": "Point by point",
    "Ключ и значение строками": "Key and value on each line",
    "Язык промпта": "Prompt language",
    "Стиль текста": "Text style",
    "Для чего": "What for",
    "Жанр или стиль": "Genre or style",
    "Что сделать": "What to do",
    "Что именно нужно": "What exactly you need",
    "Например: вечер, дождь, неон": "For example: evening, rain, neon",
    "Для {0}": "For {0}",
    "свой вариант": "your own",
    "Пишем варианты": "Writing variants",
    "Использовать в Фото": "Use in Photo",
    "Использовать в Видео": "Use in Video",
    "Закончите запись видео": "Finish recording the video",
    "Остановите запись": "Stop the recording",
    "Сделайте снимок или закройте камеру": "Take a shot or close the camera",
    "Загрузите запись или видео, или вставьте ссылку": "Upload a recording or video, or paste a link",
    "Напишите название товара первой строкой": "Write the product name on the first line",
    "Текст длиннее {0} знаков": "The text is longer than {0} characters",
    "Пожелания длиннее 300 знаков": "The wishes are longer than 300 characters",
    "Пожелания длиннее {0} знаков": "The wishes are longer than {0} characters",
    "Напишите от {0} знаков": "Write at least {0} characters",
    "Создать фото по промпту": "Create a photo from the prompt",
    "Создать видео по промпту": "Create a video from the prompt",
    "Сделать видео товара": "Make a product video",
    "Сделать описание товара": "Make a product description",
    "Текст выделен: скопируйте его вручную": "The text is selected: copy it manually",
    "Вставьте ссылку в поле": "Paste the link into the field",
    "Бот уже прислал расшифровку в чат, в отдельную тему.": "The bot has already sent the transcription to the chat, in a separate topic.",
    "Бот уже прислал текст в чат, в отдельную тему.": "The bot has already sent the text to the chat, in a separate topic.",
    "Бот уже прислал описание в чат, в отдельную тему.": "The bot has already sent the description to the chat, in a separate topic.",
    "Бот уже прислал промпт в чат, в отдельную тему.": "The bot has already sent the prompt to the chat, in a separate topic.",
    "Бот пришлёт расшифровку в чат, в отдельную тему.": "The bot will send the transcription to the chat, in a separate topic.",
    "Бот пришлёт текст в чат, в отдельную тему.": "The bot will send the text to the chat, in a separate topic.",
    "Бот пришлёт описание в чат, в отдельную тему.": "The bot will send the description to the chat, in a separate topic.",
    "Бот пришлёт промпт в чат, в отдельную тему.": "The bot will send the prompt to the chat, in a separate topic.",
    "Можно уйти с экрана: бот напишет, когда расшифровка будет готова.": "You can leave this screen: the bot will message you when the transcription is ready.",
    "Можно уйти с экрана: бот напишет, когда текст будет готов.": "You can leave this screen: the bot will message you when the text is ready.",
    "Можно уйти с экрана: бот напишет, когда описание будет готово.": "You can leave this screen: the bot will message you when the description is ready.",
    "Можно уйти с экрана: бот напишет, когда промпт будет готов.": "You can leave this screen: the bot will message you when the prompt is ready.",
    "Тут откроется тема чата, куда бот прислал расшифровку": "This opens the chat topic where the bot sent the transcription",
    "Тут откроется тема чата, куда бот прислал текст": "This opens the chat topic where the bot sent the text",
    "Тут откроется тема чата, куда бот прислал описание": "This opens the chat topic where the bot sent the description",
    "Тут откроется тема чата, куда бот прислал промпт": "This opens the chat topic where the bot sent the prompt",
    "Не удалось открыть результат.": "Could not open the result.",
    "Сбросить черновик": "Reset the draft",
    "{0}, из длинного выберете {1} секунд": "{0}, from a long one you’ll pick {1} seconds",
    "Не прошло проверку: политику и запрещённые темы не пропускаем.": "Did not pass the check: we do not allow politics or prohibited topics.",
    "{0} C списаны": "{0} C charged",
    "{0} C вернулись на баланс": "{0} C returned to the balance",
    "Попробуйте ещё раз": "Please try again",
    "Не удалось открыть варианты.": "Could not open the variants.",
    "Файл загружен": "File uploaded",
    "Распознаём речь": "Recognising speech",
    "Речь распознана": "Speech recognised",
    "Определяем, кто говорит": "Identifying the speakers",
    "Собеседники подписаны": "Speakers labelled",
    "Отмечаем время реплик": "Marking the line times",
    "Время отмечено": "Times marked",
    "Собираем текст": "Assembling the text",
    "Текст собран": "Text assembled",
    "Получаем ролик": "Getting the video",
    "Ролик получен": "Video received",
    "Пишем пересказ": "Writing the summary",
    "Пересказ готов": "Summary ready",
    "Выделяем тезисы": "Picking out the key points",
    "Тезисы готовы": "Key points ready",
    "Проверяем данные": "Checking the data",
    "Данные проверены": "Data checked",
    "Смотрим фото": "Looking at the photos",
    "Фото изучено": "Photos reviewed",
    "Пишем описание": "Writing the description",
    "Описание готово": "Description ready",
    "Подбираем ключевые слова": "Choosing keywords",
    "Ключевые слова подобраны": "Keywords chosen",
    "Смотрим кадр": "Looking at the shot",
    "Кадр изучен": "Shot reviewed",
    "Пишем промпт": "Writing the prompt",
    "Промпт готов": "Prompt ready",
    "Смотрим ролик": "Watching the video",
    "Ролик изучен": "Video reviewed",
    "Каждый блок копируется отдельно.": "Each block can be copied separately.",
    "Можно сразу создать по нему фото.": "You can create a photo from it right away.",
    "Нужна запись или видео": "A recording or a video is needed",
    "Нужна аудиозапись": "An audio recording is needed",
    "собеседник": "speaker",
    "собеседника": "speakers",
    "собеседников": "speakers",
    "Показать всё · {0}": "Show all · {0}",
    "реплика": "line",
    "реплики": "lines",
    "реплик": "lines",
    "знак": "character",
    "знака": "characters",
    "знаков": "characters",
    "пункт": "point",
    "пункта": "points",
    "пунктов": "points",
    "фраза": "phrase",
    "фразы": "phrases",
    "фраз": "phrases",
    "Промпт": "Prompt",
    "В записи не нашлось речи": "No speech was found in the recording",
    "Загрузите файл, где слышно, как говорят.": "Upload a file where people can be heard talking.",
    "Заполните, что нужно для создания": "Fill in what is needed to create",
    "Файл, запись или ссылка на YouTube: текст, кто говорит и время реплик": "A file, a recording or a YouTube link: the text, who speaks and when",
    "Расшифровка, пересказ или тезисы ролика по ссылке": "A transcription, summary or key points of a video by link",
    "Заголовок, описание и ключевые слова для карточки товара": "A title, description and keywords for a product card",
    "Промпт из видео": "Prompt from a video",
    "Опишем сцену, движение камеры и свет ролика": "We’ll describe the scene, camera movement and light of the video",
    "Подробный промпт из короткой идеи": "A detailed prompt from a short idea",
    "Добавим детали, стиль и свет": "We’ll add details, style and light",
    "Полный текст": "Full text",
    "Краткий пересказ": "Short summary",
    "Как в ролике": "As in the video",
    "Свой сайт": "Own website",
    "Тишина и 40 часов музыки": "Silence and 40 hours of music",
    "Шумоподавление выключает город, заряда хватит на неделю": "Noise cancelling switches off the city, the charge lasts a week",
    "Bluetooth 5.3, ANC до 35 дБ": "Bluetooth 5.3, ANC up to 35 dB",
    "Кодеки AAC и SBC, 10 минут заряда дают 4 часа музыки": "AAC and SBC codecs, 10 minutes of charging give 4 hours of music",
    "Беспроводные наушники": "Wireless headphones",
    "Шумоподавление, до 40 часов работы, мягкие амбушюры": "Noise cancelling, up to 40 hours of battery, soft ear cushions",
    "Звук, который слышно в деталях": "Sound you hear in every detail",
    "Эко-кожа, мягкая посадка и тишина вокруг": "Eco-leather, a soft fit and silence around you",
    "Город станет тише": "The city will get quieter",
    "Наденьте и слушайте любимое хоть всю неделю": "Put them on and listen to your favourites all week",
    "Коротко": "Short",
    "Тихо. Долго. Удобно": "Quiet. Long-lasting. Comfortable",
    "40 часов, шумоподавление, мягкие амбушюры": "40 hours, noise cancelling, soft ear cushions",
    "Подарок на каждый день": "A gift for every day",
    "В коробке кабель и чехол, можно дарить сразу": "A cable and a case in the box, ready to give right away",
    "Для поиска": "For search",
    "Наушники беспроводные с шумоподавлением": "Wireless headphones with noise cancelling",
    "Накладные, с микрофоном, складные, для телефона": "On-ear, with a microphone, foldable, for a phone",
    "коротко и по делу": "brief and to the point",
    "Простыми словами": "In simple words",
    "простыми словами, без терминов": "in simple words, without jargon",
    "Подробно": "In detail",
    "подробно, с деталями": "in detail, with specifics",
    "Без эмодзи": "No emoji",
    "без эмодзи": "no emoji",
    "Идея": "Idea",
    "О чём промпт? Например: кот-астронавт сидит на Луне и смотрит на Землю": "What is the prompt about? For example: an astronaut cat sits on the Moon looking at the Earth",
    "Политику и запрещённые темы не пропустим": "We won’t let politics or prohibited topics through",
    "Ваш промпт": "Your prompt",
    "Вставьте промпт, который хотите улучшить": "Paste the prompt you want to improve",
    "Название и преимущества": "Name and benefits",
    "Флисовая куртка женская на молнии Плотный мягкий флис Два боковых кармана": "Women’s zip-up fleece jacket\nDense soft fleece\nTwo side pockets",
    "Название первой строкой, ниже по преимуществу": "The name on the first line, then one benefit per line",
    "Кот-астронавт": "Astronaut cat",
    "Рыжий кот-астронавт сидит на Луне и смотрит на Землю": "A ginger astronaut cat sits on the Moon looking at the Earth",
    "Город будущего": "City of the future",
    "Ночной город будущего, летающие машины и неоновые вывески": "A night city of the future, flying cars and neon signs",
    "Уютное кафе": "Cozy café",
    "Уютное кафе у окна в дождливое утро": "A cozy café by the window on a rainy morning",
    "Горы на рассвете": "Mountains at dawn",
    "Горное озеро на рассвете, туман над водой": "A mountain lake at dawn, mist over the water",
    "Портрет в студии": "Studio portrait",
    "Студийный портрет девушки в мягком свете": "A studio portrait of a young woman in soft light",
    "фото": "photo",
    "видео": "video",
    "музыки": "music",
    "текста": "text",
    "Расшифровка готова": "Transcription ready",
    "текст не создан": "the text was not created",
    "Не получилось распознать речь": "Could not recognise the speech",
    "Получаем текст ролика": "Getting the video text",
    "Ролик не прошёл проверку": "The video did not pass the check",
    "Не получилось получить текст": "Could not get the text",
    "Заменить ссылку": "Replace the link",
    "Пишем описание товара": "Writing the product description",
    "Описание не прошло проверку": "The description did not pass the check",
    "описание не создано": "the description was not created",
    "Не получилось написать описание": "Could not write the description",
    "Описание не создано": "The description was not created",
    "Фото не прошло проверку": "The photo did not pass the check",
    "промпт не создан": "the prompt was not created",
    "Не получилось создать промпт": "Could not create the prompt",
    "Промпт не создан": "The prompt was not created",
    "Заменить фото": "Replace the photo",
    "Видео не прошло проверку": "The video did not pass the check",
    "Заменить видео": "Replace video",
    "Получить текст": "Get the text",
    "Создать описание": "Create a description",
    "за текст ролика": "per video text",
    "за описание": "per description",
    "за промпт": "per prompt",
    "за варианты": "per set of variants",
    "Фотореализм": "Photorealism",
    "Кино": "Cinema",
    "Аниме": "Anime",
    "Акварель": "Watercolour",
    "Неон": "Neon",
    "Минимализм": "Minimalism",
    "3D-мультфильм": "3D cartoon",
    "Документальный": "Documentary",
    "Замедление": "Slow motion",
    "Эмбиент": "Ambient",
    "Лоу-фай": "Lo-fi",
    "Поп": "Pop",
    "Оркестр": "Orchestra",
    "Синтвейв": "Synthwave",
    "Джаз": "Jazz",
    "Деловой": "Business",
    "Ироничный": "Ironic",
    "Научный": "Scientific",
    "Поэтичный": "Poetic",
    "Кинематографичнее": "More cinematic",
    "Свет и цвет": "Light and colour",
    "Реализм": "Realism",
    "Движение камеры": "Camera movement",
    "Жанр и темп": "Genre and tempo",
    "Настроение": "Mood",
    "Без вокала": "No vocals",
    "Проще": "Simpler",
    "Структура": "Structure",
    "Тон": "Tone",
    "С примером": "With an example"
  },
  "hy": {
    "Загрузите запись или видео": "Վերբեռնեք ձայնագրություն կամ տեսանյութ",
    "Разговор, интервью, лекция или голосовое": "Զրույց, հարցազրույց, դասախոսություն կամ ձայնային հաղորդագրություն",
    "Загрузите фото товара": "Վերբեռնեք ապրանքի լուսանկարը",
    "Необязательно: по фото опишем детали точнее": "Պարտադիր չէ․ լուսանկարներով մանրամասները ավելի ճշգրիտ կնկարագրենք",
    "По фото найдём материал, цвет и детали": "Լուսանկարներից կգտնենք նյութը, գույնը և մանրամասները",
    "Опишем снимок так, чтобы его можно было повторить": "Կնկարագրենք կադրն այնպես, որ այն հնարավոր լինի կրկնել",
    "Опишем сцену, движение камеры и свет": "Կնկարագրենք տեսարանը, տեսախցիկի շարժումը և լույսը",
    "Вставить": "Տեղադրել",
    "Это не ссылка на ролик YouTube": "Սա YouTube տեսանյութի հղում չէ",
    "Ссылка на YouTube": "YouTube հղում",
    "Или ссылка на YouTube": "Կամ YouTube հղում",
    "Ссылка на ролик YouTube": "YouTube տեսանյութի հղում",
    "Весь текст": "Ամբողջ տեքստը",
    "С временем абзацев": "Պարբերությունների ժամանակով",
    "Пересказ": "Վերապատմում",
    "Главное в нескольких абзацах": "Գլխավորը մի քանի պարբերությամբ",
    "Тезисы": "Թեզեր",
    "Коротко по пунктам": "Համառոտ՝ կետերով",
    "Язык текста": "Տեքստի լեզուն",
    "Исходный": "Բնօրինակ",
    "Подписать собеседников": "Նշել զրուցակիցներին",
    "Без имён": "Առանց անունների",
    "Время реплик": "Ռեպլիկների ժամանակը",
    "В начале каждой реплики": "Յուրաքանչյուր ռեպլիկի սկզբում",
    "Без времени": "Առանց ժամանակի",
    "Время в начале каждой реплики": "Ժամանակը յուրաքանչյուր ռեպլիկի սկզբում",
    "Я.Маркет": "Y.Market",
    "Общая для товарных инструментов": "Ընդհանուր ապրանքային գործիքների համար",
    "Только для описания": "Միայն նկարագրության համար",
    "Например: коротко, простыми словами": "Օրինակ՝ համառոտ, պարզ բառերով",
    "Стиль промпта": "Պրոմպտի ոճը",
    "Одна-две фразы": "Մեկ-երկու նախադասություն",
    "Сцена, свет, камера, стиль": "Տեսարան, լույս, տեսախցիկ, ոճ",
    "По пунктам": "Կետերով",
    "Ключ и значение строками": "Բանալի և արժեք՝ տողերով",
    "Язык промпта": "Պրոմպտի լեզուն",
    "Стиль текста": "Տեքստի ոճը",
    "Для чего": "Ինչի համար",
    "Жанр или стиль": "Ժանր կամ ոճ",
    "Что сделать": "Ինչ անել",
    "Что именно нужно": "Ինչ է հենց պետք",
    "Например: вечер, дождь, неон": "Օրինակ՝ երեկո, անձրև, նեոն",
    "Для {0}": "{0} համար",
    "свой вариант": "ձեր տարբերակը",
    "Пишем варианты": "Գրում ենք տարբերակները",
    "Использовать в Фото": "Օգտագործել Լուսանկարում",
    "Использовать в Видео": "Օգտագործել Տեսանյութում",
    "Закончите запись видео": "Ավարտեք տեսանյութի ձայնագրումը",
    "Остановите запись": "Դադարեցրեք ձայնագրումը",
    "Сделайте снимок или закройте камеру": "Լուսանկարեք կամ փակեք տեսախցիկը",
    "Загрузите запись или видео, или вставьте ссылку": "Վերբեռնեք ձայնագրություն կամ տեսանյութ, կամ տեղադրեք հղում",
    "Напишите название товара первой строкой": "Գրեք ապրանքի անվանումն առաջին տողում",
    "Текст длиннее {0} знаков": "Տեքստը {0} նիշից երկար է",
    "Пожелания длиннее 300 знаков": "Ցանկությունները 300 նիշից երկար են",
    "Пожелания длиннее {0} знаков": "Ցանկությունները {0} նիշից երկար են",
    "Напишите от {0} знаков": "Գրեք առնվազն {0} նիշ",
    "Создать фото по промпту": "Ստեղծել լուսանկար պրոմպտով",
    "Создать видео по промпту": "Ստեղծել տեսանյութ պրոմպտով",
    "Сделать видео товара": "Պատրաստել ապրանքի տեսանյութ",
    "Сделать описание товара": "Պատրաստել ապրանքի նկարագրություն",
    "Текст выделен: скопируйте его вручную": "Տեքստը նշված է․ պատճենեք այն ձեռքով",
    "Вставьте ссылку в поле": "Տեղադրեք հղումը դաշտում",
    "Бот уже прислал расшифровку в чат, в отдельную тему.": "Բոտն արդեն ուղարկել է տառադարձումը չաթ՝ առանձին թեմայում։",
    "Бот уже прислал текст в чат, в отдельную тему.": "Բոտն արդեն ուղարկել է տեքստը չաթ՝ առանձին թեմայում։",
    "Бот уже прислал описание в чат, в отдельную тему.": "Բոտն արդեն ուղարկել է նկարագրությունը չաթ՝ առանձին թեմայում։",
    "Бот уже прислал промпт в чат, в отдельную тему.": "Բոտն արդեն ուղարկել է պրոմպտը չաթ՝ առանձին թեմայում։",
    "Бот пришлёт расшифровку в чат, в отдельную тему.": "Բոտը տառադարձումը կուղարկի չաթ՝ առանձին թեմայում։",
    "Бот пришлёт текст в чат, в отдельную тему.": "Բոտը տեքստը կուղարկի չաթ՝ առանձին թեմայում։",
    "Бот пришлёт описание в чат, в отдельную тему.": "Բոտը նկարագրությունը կուղարկի չաթ՝ առանձին թեմայում։",
    "Бот пришлёт промпт в чат, в отдельную тему.": "Բոտը պրոմպտը կուղարկի չաթ՝ առանձին թեմայում։",
    "Можно уйти с экрана: бот напишет, когда расшифровка будет готова.": "Կարող եք լքել էկրանը․ բոտը կգրի, երբ տառադարձումը պատրաստ լինի։",
    "Можно уйти с экрана: бот напишет, когда текст будет готов.": "Կարող եք լքել էկրանը․ բոտը կգրի, երբ տեքստը պատրաստ լինի։",
    "Можно уйти с экрана: бот напишет, когда описание будет готово.": "Կարող եք լքել էկրանը․ բոտը կգրի, երբ նկարագրությունը պատրաստ լինի։",
    "Можно уйти с экрана: бот напишет, когда промпт будет готов.": "Կարող եք լքել էկրանը․ բոտը կգրի, երբ պրոմպտը պատրաստ լինի։",
    "Тут откроется тема чата, куда бот прислал расшифровку": "Այստեղ կբացվի չաթի թեման, որտեղ բոտն ուղարկել է տառադարձումը",
    "Тут откроется тема чата, куда бот прислал текст": "Այստեղ կբացվի չաթի թեման, որտեղ բոտն ուղարկել է տեքստը",
    "Тут откроется тема чата, куда бот прислал описание": "Այստեղ կբացվի չաթի թեման, որտեղ բոտն ուղարկել է նկարագրությունը",
    "Тут откроется тема чата, куда бот прислал промпт": "Այստեղ կբացվի չաթի թեման, որտեղ բոտն ուղարկել է պրոմպտը",
    "Не удалось открыть результат.": "Չհաջողվեց բացել արդյունքը։",
    "Сбросить черновик": "Զրոյացնել սևագիրը",
    "{0}, из длинного выберете {1} секунд": "{0}, երկարից կընտրեք {1} վայրկյան",
    "Не прошло проверку: политику и запрещённые темы не пропускаем.": "Չանցավ ստուգումը․ քաղաքականություն և արգելված թեմաներ թույլ չենք տալիս։",
    "{0} C списаны": "{0} C դուրս է գրվել",
    "{0} C вернулись на баланс": "{0} C վերադարձվել է հաշվեկշռին",
    "Попробуйте ещё раз": "Փորձեք կրկին",
    "Не удалось открыть варианты.": "Չհաջողվեց բացել տարբերակները։",
    "Файл загружен": "Ֆայլը վերբեռնված է",
    "Распознаём речь": "Ճանաչում ենք խոսքը",
    "Речь распознана": "Խոսքը ճանաչված է",
    "Определяем, кто говорит": "Որոշում ենք, թե ով է խոսում",
    "Собеседники подписаны": "Զրուցակիցները նշված են",
    "Отмечаем время реплик": "Նշում ենք ռեպլիկների ժամանակը",
    "Время отмечено": "Ժամանակը նշված է",
    "Собираем текст": "Հավաքում ենք տեքստը",
    "Текст собран": "Տեքստը հավաքված է",
    "Получаем ролик": "Ստանում ենք տեսանյութը",
    "Ролик получен": "Տեսանյութը ստացված է",
    "Пишем пересказ": "Գրում ենք վերապատմումը",
    "Пересказ готов": "Վերապատմումը պատրաստ է",
    "Выделяем тезисы": "Առանձնացնում ենք թեզերը",
    "Тезисы готовы": "Թեզերը պատրաստ են",
    "Проверяем данные": "Ստուգում ենք տվյալները",
    "Данные проверены": "Տվյալները ստուգված են",
    "Смотрим фото": "Դիտում ենք լուսանկարները",
    "Фото изучено": "Լուսանկարներն ուսումնասիրված են",
    "Пишем описание": "Գրում ենք նկարագրությունը",
    "Описание готово": "Նկարագրությունը պատրաստ է",
    "Подбираем ключевые слова": "Ընտրում ենք հիմնաբառերը",
    "Ключевые слова подобраны": "Հիմնաբառերն ընտրված են",
    "Смотрим кадр": "Դիտում ենք կադրը",
    "Кадр изучен": "Կադրն ուսումնասիրված է",
    "Пишем промпт": "Գրում ենք պրոմպտը",
    "Промпт готов": "Պրոմպտը պատրաստ է",
    "Смотрим ролик": "Դիտում ենք տեսանյութը",
    "Ролик изучен": "Տեսանյութն ուսումնասիրված է",
    "Каждый блок копируется отдельно.": "Յուրաքանչյուր բլոկ պատճենվում է առանձին։",
    "Можно сразу создать по нему фото.": "Կարող եք անմիջապես դրանով լուսանկար ստեղծել։",
    "Нужна запись или видео": "Անհրաժեշտ է ձայնագրություն կամ տեսանյութ",
    "Нужна аудиозапись": "Անհրաժեշտ է աուդիոձայնագրություն",
    "собеседник": "զրուցակից",
    "собеседника": "զրուցակից",
    "собеседников": "զրուցակից",
    "Показать всё · {0}": "Ցույց տալ բոլորը · {0}",
    "реплика": "ռեպլիկ",
    "реплики": "ռեպլիկ",
    "реплик": "ռեպլիկ",
    "знак": "նիշ",
    "знака": "նիշ",
    "знаков": "նիշ",
    "пункт": "կետ",
    "пункта": "կետ",
    "пунктов": "կետ",
    "фраза": "արտահայտություն",
    "фразы": "արտահայտություն",
    "фраз": "արտահայտություն",
    "Промпт": "Պրոմպտ",
    "В записи не нашлось речи": "Ձայնագրության մեջ խոսք չգտնվեց",
    "Загрузите файл, где слышно, как говорят.": "Վերբեռնեք ֆայլ, որտեղ լսվում է խոսքը։",
    "Заполните, что нужно для создания": "Լրացրեք ստեղծման համար անհրաժեշտը",
    "Файл, запись или ссылка на YouTube: текст, кто говорит и время реплик": "Ֆայլ, ձայնագրություն կամ YouTube հղում․ տեքստը, ով է խոսում և երբ",
    "Расшифровка, пересказ или тезисы ролика по ссылке": "Տեսանյութի տառադարձում, վերապատմում կամ թեզեր՝ հղումով",
    "Заголовок, описание и ключевые слова для карточки товара": "Վերնագիր, նկարագրություն և հիմնաբառեր ապրանքի քարտի համար",
    "Промпт из видео": "Պրոմպտ տեսանյութից",
    "Опишем сцену, движение камеры и свет ролика": "Կնկարագրենք տեսանյութի տեսարանը, տեսախցիկի շարժումը և լույսը",
    "Подробный промпт из короткой идеи": "Մանրամասն պրոմպտ կարճ գաղափարից",
    "Добавим детали, стиль и свет": "Կավելացնենք մանրամասներ, ոճ և լույս",
    "Полный текст": "Ամբողջական տեքստ",
    "Краткий пересказ": "Համառոտ վերապատմում",
    "Как в ролике": "Ինչպես տեսանյութում",
    "Свой сайт": "Սեփական կայք",
    "Тишина и 40 часов музыки": "Լռություն և 40 ժամ երաժշտություն",
    "Шумоподавление выключает город, заряда хватит на неделю": "Աղմուկի ճնշումն անջատում է քաղաքը, լիցքը բավական է մեկ շաբաթ",
    "Bluetooth 5.3, ANC до 35 дБ": "Bluetooth 5.3, ANC մինչև 35 դԲ",
    "Кодеки AAC и SBC, 10 минут заряда дают 4 часа музыки": "AAC և SBC կոդեկներ, 10 րոպե լիցքավորումը տալիս է 4 ժամ երաժշտություն",
    "Беспроводные наушники": "Անլար ականջակալներ",
    "Шумоподавление, до 40 часов работы, мягкие амбушюры": "Աղմուկի ճնշում, մինչև 40 ժամ աշխատանք, փափուկ բարձիկներ",
    "Звук, который слышно в деталях": "Ձայն, որը լսվում է մանրամասներով",
    "Эко-кожа, мягкая посадка и тишина вокруг": "Էկո-կաշի, փափուկ նստվածք և լռություն շուրջը",
    "Город станет тише": "Քաղաքը ավելի հանգիստ կդառնա",
    "Наденьте и слушайте любимое хоть всю неделю": "Հագեք և լսեք սիրելին գոնե ամբողջ շաբաթ",
    "Коротко": "Համառոտ",
    "Тихо. Долго. Удобно": "Հանգիստ։ Երկար։ Հարմար",
    "40 часов, шумоподавление, мягкие амбушюры": "40 ժամ, աղմուկի ճնշում, փափուկ բարձիկներ",
    "Подарок на каждый день": "Նվեր ամեն օրվա համար",
    "В коробке кабель и чехол, можно дарить сразу": "Տուփում կա մալուխ և պատյան, կարելի է անմիջապես նվիրել",
    "Для поиска": "Որոնման համար",
    "Наушники беспроводные с шумоподавлением": "Անլար ականջակալներ աղմուկի ճնշմամբ",
    "Накладные, с микрофоном, складные, для телефона": "Վրադրվող, միկրոֆոնով, ծալովի, հեռախոսի համար",
    "коротко и по делу": "համառոտ և ըստ էության",
    "Простыми словами": "Պարզ բառերով",
    "простыми словами, без терминов": "պարզ բառերով, առանց տերմինների",
    "Подробно": "Մանրամասն",
    "подробно, с деталями": "մանրամասն, մանրուքներով",
    "Без эмодзи": "Առանց էմոջիների",
    "без эмодзи": "առանց էմոջիների",
    "Идея": "Գաղափար",
    "О чём промпт? Например: кот-астронавт сидит на Луне и смотрит на Землю": "Ինչի՞ մասին է պրոմպտը։ Օրինակ՝ կատու-տիեզերագնացը նստած է Լուսնի վրա և նայում է Երկրին",
    "Политику и запрещённые темы не пропустим": "Քաղաքականությունն ու արգելված թեմաները չենք թողնի",
    "Ваш промпт": "Ձեր պրոմպտը",
    "Вставьте промпт, который хотите улучшить": "Տեղադրեք այն պրոմպտը, որը ցանկանում եք բարելավել",
    "Название и преимущества": "Անվանում և առավելություններ",
    "Флисовая куртка женская на молнии Плотный мягкий флис Два боковых кармана": "Կանացի ֆլիսե բաճկոն՝ շղթայով\nԽիտ փափուկ ֆլիս\nԵրկու կողային գրպան",
    "Название первой строкой, ниже по преимуществу": "Անվանումը՝ առաջին տողում, ներքևում՝ մեկական առավելություն",
    "Кот-астронавт": "Կատու-տիեզերագնաց",
    "Рыжий кот-астронавт сидит на Луне и смотрит на Землю": "Շիկահեր կատու-տիեզերագնացը նստած է Լուսնի վրա և նայում է Երկրին",
    "Город будущего": "Ապագայի քաղաք",
    "Ночной город будущего, летающие машины и неоновые вывески": "Ապագայի գիշերային քաղաք, թռչող մեքենաներ և նեոնային ցուցանակներ",
    "Уютное кафе": "Հարմարավետ սրճարան",
    "Уютное кафе у окна в дождливое утро": "Հարմարավետ սրճարան պատուհանի մոտ՝ անձրևոտ առավոտյան",
    "Горы на рассвете": "Լեռները արշալույսին",
    "Горное озеро на рассвете, туман над водой": "Լեռնային լիճ արշալույսին, մառախուղ ջրի վրա",
    "Портрет в студии": "Դիմանկար ստուդիայում",
    "Студийный портрет девушки в мягком свете": "Աղջկա ստուդիական դիմանկար մեղմ լույսի ներքո",
    "фото": "լուսանկարի",
    "видео": "տեսանյութ",
    "музыки": "երաժշտության",
    "текста": "տեքստի",
    "Расшифровка готова": "Տառադարձումը պատրաստ է",
    "текст не создан": "տեքստը չի ստեղծվել",
    "Не получилось распознать речь": "Չհաջողվեց ճանաչել խոսքը",
    "Получаем текст ролика": "Ստանում ենք տեսանյութի տեքստը",
    "Ролик не прошёл проверку": "Տեսանյութը չանցավ ստուգումը",
    "Не получилось получить текст": "Չհաջողվեց ստանալ տեքստը",
    "Заменить ссылку": "Փոխել հղումը",
    "Пишем описание товара": "Գրում ենք ապրանքի նկարագրությունը",
    "Описание не прошло проверку": "Նկարագրությունը չանցավ ստուգումը",
    "описание не создано": "նկարագրությունը չի ստեղծվել",
    "Не получилось написать описание": "Չհաջողվեց գրել նկարագրությունը",
    "Описание не создано": "Նկարագրությունը չի ստեղծվել",
    "Фото не прошло проверку": "Լուսանկարը չանցավ ստուգումը",
    "промпт не создан": "պրոմպտը չի ստեղծվել",
    "Не получилось создать промпт": "Չհաջողվեց ստեղծել պրոմպտը",
    "Промпт не создан": "Պրոմպտը չի ստեղծվել",
    "Заменить фото": "Փոխել լուսանկարը",
    "Видео не прошло проверку": "Տեսանյութը չանցավ ստուգումը",
    "Заменить видео": "Փոխարինել տեսանյութը",
    "Получить текст": "Ստանալ տեքստը",
    "Создать описание": "Ստեղծել նկարագրություն",
    "за текст ролика": "տեսանյութի տեքստի համար",
    "за описание": "նկարագրության համար",
    "за промпт": "պրոմպտի համար",
    "за варианты": "տարբերակների համար",
    "Фотореализм": "Ֆոտոռեալիզմ",
    "Кино": "Կինո",
    "Аниме": "Անիմե",
    "Акварель": "Ջրաներկ",
    "Неон": "Նեոն",
    "Минимализм": "Մինիմալիզմ",
    "3D-мультфильм": "3D մուլտֆիլմ",
    "Документальный": "Վավերագրական",
    "Замедление": "Դանդաղեցում",
    "Эмбиент": "Էմբիենտ",
    "Лоу-фай": "Լո-ֆայ",
    "Поп": "Փոփ",
    "Оркестр": "Նվագախումբ",
    "Синтвейв": "Սինթվեյվ",
    "Джаз": "Ջազ",
    "Деловой": "Գործնական",
    "Ироничный": "Հեգնական",
    "Научный": "Գիտական",
    "Поэтичный": "Բանաստեղծական",
    "Кинематографичнее": "Ավելի կինեմատոգրաֆիկ",
    "Свет и цвет": "Լույս և գույն",
    "Реализм": "Ռեալիզմ",
    "Движение камеры": "Տեսախցիկի շարժում",
    "Жанр и темп": "Ժանր և տեմպ",
    "Настроение": "Տրամադրություն",
    "Без вокала": "Առանց վոկալի",
    "Проще": "Ավելի պարզ",
    "Структура": "Կառուցվածք",
    "Тон": "Տոն",
    "С примером": "Օրինակով"
  },
  "es": {
    "Загрузите запись или видео": "Sube una grabación o un vídeo",
    "Разговор, интервью, лекция или голосовое": "Una conversación, entrevista, clase o nota de voz",
    "Загрузите фото товара": "Sube una foto del producto",
    "Необязательно: по фото опишем детали точнее": "Opcional: con fotos describiremos los detalles con más precisión",
    "По фото найдём материал, цвет и детали": "En las fotos encontraremos el material, el color y los detalles",
    "Опишем снимок так, чтобы его можно было повторить": "Describiremos la foto para que se pueda recrear",
    "Опишем сцену, движение камеры и свет": "Describiremos la escena, el movimiento de cámara y la luz",
    "Вставить": "Pegar",
    "Это не ссылка на ролик YouTube": "Esto no es un enlace a un vídeo de YouTube",
    "Ссылка на YouTube": "Enlace de YouTube",
    "Или ссылка на YouTube": "O un enlace de YouTube",
    "Ссылка на ролик YouTube": "Enlace a un vídeo de YouTube",
    "Весь текст": "Texto completo",
    "С временем абзацев": "Con la hora de cada párrafo",
    "Пересказ": "Resumen",
    "Главное в нескольких абзацах": "Lo esencial en unos párrafos",
    "Тезисы": "Puntos clave",
    "Коротко по пунктам": "En breve, por puntos",
    "Язык текста": "Idioma del texto",
    "Исходный": "Original",
    "Подписать собеседников": "Identificar a los hablantes",
    "Без имён": "Sin nombres",
    "Время реплик": "Hora de las intervenciones",
    "В начале каждой реплики": "Al inicio de cada intervención",
    "Без времени": "Sin hora",
    "Время в начале каждой реплики": "Hora al inicio de cada intervención",
    "Я.Маркет": "Y.Market",
    "Общая для товарных инструментов": "Compartida por las herramientas de producto",
    "Только для описания": "Solo para la descripción",
    "Например: коротко, простыми словами": "Por ejemplo: breve, con palabras sencillas",
    "Стиль промпта": "Estilo del prompt",
    "Одна-две фразы": "Una o dos frases",
    "Сцена, свет, камера, стиль": "Escena, luz, cámara, estilo",
    "По пунктам": "Por puntos",
    "Ключ и значение строками": "Clave y valor en cada línea",
    "Язык промпта": "Idioma del prompt",
    "Стиль текста": "Estilo del texto",
    "Для чего": "Para qué",
    "Жанр или стиль": "Género o estilo",
    "Что сделать": "Qué hacer",
    "Что именно нужно": "Qué necesitas exactamente",
    "Например: вечер, дождь, неон": "Por ejemplo: tarde, lluvia, neón",
    "Для {0}": "Para {0}",
    "свой вариант": "tu opción",
    "Пишем варианты": "Escribiendo variantes",
    "Использовать в Фото": "Usar en Foto",
    "Использовать в Видео": "Usar en Vídeo",
    "Закончите запись видео": "Termina de grabar el vídeo",
    "Остановите запись": "Detén la grabación",
    "Сделайте снимок или закройте камеру": "Haz una foto o cierra la cámara",
    "Загрузите запись или видео, или вставьте ссылку": "Sube una grabación o un vídeo, o pega un enlace",
    "Напишите название товара первой строкой": "Escribe el nombre del producto en la primera línea",
    "Текст длиннее {0} знаков": "El texto tiene más de {0} caracteres",
    "Пожелания длиннее 300 знаков": "Las preferencias superan los 300 caracteres",
    "Пожелания длиннее {0} знаков": "Las preferencias superan los {0} caracteres",
    "Напишите от {0} знаков": "Escribe al menos {0} caracteres",
    "Создать фото по промпту": "Crear una foto con el prompt",
    "Создать видео по промпту": "Crear un vídeo con el prompt",
    "Сделать видео товара": "Hacer un vídeo del producto",
    "Сделать описание товара": "Hacer una descripción del producto",
    "Текст выделен: скопируйте его вручную": "El texto está seleccionado: cópialo a mano",
    "Вставьте ссылку в поле": "Pega el enlace en el campo",
    "Бот уже прислал расшифровку в чат, в отдельную тему.": "El bot ya ha enviado la transcripción al chat, en un tema aparte.",
    "Бот уже прислал текст в чат, в отдельную тему.": "El bot ya ha enviado el texto al chat, en un tema aparte.",
    "Бот уже прислал описание в чат, в отдельную тему.": "El bot ya ha enviado la descripción al chat, en un tema aparte.",
    "Бот уже прислал промпт в чат, в отдельную тему.": "El bot ya ha enviado el prompt al chat, en un tema aparte.",
    "Бот пришлёт расшифровку в чат, в отдельную тему.": "El bot enviará la transcripción al chat, en un tema aparte.",
    "Бот пришлёт текст в чат, в отдельную тему.": "El bot enviará el texto al chat, en un tema aparte.",
    "Бот пришлёт описание в чат, в отдельную тему.": "El bot enviará la descripción al chat, en un tema aparte.",
    "Бот пришлёт промпт в чат, в отдельную тему.": "El bot enviará el prompt al chat, en un tema aparte.",
    "Можно уйти с экрана: бот напишет, когда расшифровка будет готова.": "Puedes salir de la pantalla: el bot te escribirá cuando la transcripción esté lista.",
    "Можно уйти с экрана: бот напишет, когда текст будет готов.": "Puedes salir de la pantalla: el bot te escribirá cuando el texto esté listo.",
    "Можно уйти с экрана: бот напишет, когда описание будет готово.": "Puedes salir de la pantalla: el bot te escribirá cuando la descripción esté lista.",
    "Можно уйти с экрана: бот напишет, когда промпт будет готов.": "Puedes salir de la pantalla: el bot te escribirá cuando el prompt esté listo.",
    "Тут откроется тема чата, куда бот прислал расшифровку": "Aquí se abrirá el tema del chat donde el bot envió la transcripción",
    "Тут откроется тема чата, куда бот прислал текст": "Aquí se abrirá el tema del chat donde el bot envió el texto",
    "Тут откроется тема чата, куда бот прислал описание": "Aquí se abrirá el tema del chat donde el bot envió la descripción",
    "Тут откроется тема чата, куда бот прислал промпт": "Aquí se abrirá el tema del chat donde el bot envió el prompt",
    "Не удалось открыть результат.": "No se pudo abrir el resultado.",
    "Сбросить черновик": "Restablecer el borrador",
    "{0}, из длинного выберете {1} секунд": "{0}, de uno largo elegirás {1} segundos",
    "Не прошло проверку: политику и запрещённые темы не пропускаем.": "No superó la revisión: no permitimos política ni temas prohibidos.",
    "{0} C списаны": "{0} C cobrados",
    "{0} C вернулись на баланс": "{0} C devueltos al saldo",
    "Попробуйте ещё раз": "Inténtalo de nuevo",
    "Не удалось открыть варианты.": "No se pudieron abrir las variantes.",
    "Файл загружен": "Archivo subido",
    "Распознаём речь": "Reconociendo el habla",
    "Речь распознана": "Habla reconocida",
    "Определяем, кто говорит": "Identificando quién habla",
    "Собеседники подписаны": "Hablantes identificados",
    "Отмечаем время реплик": "Marcando la hora de las intervenciones",
    "Время отмечено": "Horas marcadas",
    "Собираем текст": "Componiendo el texto",
    "Текст собран": "Texto compuesto",
    "Получаем ролик": "Obteniendo el vídeo",
    "Ролик получен": "Vídeo obtenido",
    "Пишем пересказ": "Escribiendo el resumen",
    "Пересказ готов": "Resumen listo",
    "Выделяем тезисы": "Extrayendo los puntos clave",
    "Тезисы готовы": "Puntos clave listos",
    "Проверяем данные": "Comprobando los datos",
    "Данные проверены": "Datos comprobados",
    "Смотрим фото": "Revisando las fotos",
    "Фото изучено": "Fotos revisadas",
    "Пишем описание": "Escribiendo la descripción",
    "Описание готово": "Descripción lista",
    "Подбираем ключевые слова": "Eligiendo las palabras clave",
    "Ключевые слова подобраны": "Palabras clave elegidas",
    "Смотрим кадр": "Revisando la foto",
    "Кадр изучен": "Foto revisada",
    "Пишем промпт": "Escribiendo el prompt",
    "Промпт готов": "Prompt listo",
    "Смотрим ролик": "Revisando el vídeo",
    "Ролик изучен": "Vídeo revisado",
    "Каждый блок копируется отдельно.": "Cada bloque se copia por separado.",
    "Можно сразу создать по нему фото.": "Puedes crear una foto con él al momento.",
    "Нужна запись или видео": "Se necesita una grabación o un vídeo",
    "Нужна аудиозапись": "Se necesita una grabación de audio",
    "собеседник": "hablante",
    "собеседника": "hablantes",
    "собеседников": "hablantes",
    "Показать всё · {0}": "Mostrar todo · {0}",
    "реплика": "intervención",
    "реплики": "intervenciones",
    "реплик": "intervenciones",
    "знак": "carácter",
    "знака": "caracteres",
    "знаков": "caracteres",
    "пункт": "punto",
    "пункта": "puntos",
    "пунктов": "puntos",
    "фраза": "frase",
    "фразы": "frases",
    "фраз": "frases",
    "Промпт": "Prompt",
    "В записи не нашлось речи": "No se encontró habla en la grabación",
    "Загрузите файл, где слышно, как говорят.": "Sube un archivo en el que se oiga hablar.",
    "Заполните, что нужно для создания": "Completa lo necesario para crear",
    "Файл, запись или ссылка на YouTube: текст, кто говорит и время реплик": "Un archivo, una grabación o un enlace de YouTube: el texto, quién habla y cuándo",
    "Расшифровка, пересказ или тезисы ролика по ссылке": "Transcripción, resumen o puntos clave de un vídeo por enlace",
    "Заголовок, описание и ключевые слова для карточки товара": "Título, descripción y palabras clave para la ficha del producto",
    "Промпт из видео": "Prompt desde vídeo",
    "Опишем сцену, движение камеры и свет ролика": "Describiremos la escena, el movimiento de cámara y la luz del vídeo",
    "Подробный промпт из короткой идеи": "Un prompt detallado a partir de una idea corta",
    "Добавим детали, стиль и свет": "Añadiremos detalles, estilo y luz",
    "Полный текст": "Texto completo",
    "Краткий пересказ": "Resumen breve",
    "Как в ролике": "Como en el vídeo",
    "Свой сайт": "Sitio propio",
    "Тишина и 40 часов музыки": "Silencio y 40 horas de música",
    "Шумоподавление выключает город, заряда хватит на неделю": "La cancelación de ruido apaga la ciudad, la batería dura una semana",
    "Bluetooth 5.3, ANC до 35 дБ": "Bluetooth 5.3, ANC de hasta 35 dB",
    "Кодеки AAC и SBC, 10 минут заряда дают 4 часа музыки": "Códecs AAC y SBC, 10 minutos de carga dan 4 horas de música",
    "Беспроводные наушники": "Auriculares inalámbricos",
    "Шумоподавление, до 40 часов работы, мягкие амбушюры": "Cancelación de ruido, hasta 40 horas de batería, almohadillas suaves",
    "Звук, который слышно в деталях": "Un sonido que se oye en cada detalle",
    "Эко-кожа, мягкая посадка и тишина вокруг": "Piel ecológica, ajuste suave y silencio alrededor",
    "Город станет тише": "La ciudad se volverá más tranquila",
    "Наденьте и слушайте любимое хоть всю неделю": "Póntelos y escucha lo que te gusta toda la semana",
    "Коротко": "Breve",
    "Тихо. Долго. Удобно": "Silencioso. Duradero. Cómodo",
    "40 часов, шумоподавление, мягкие амбушюры": "40 horas, cancelación de ruido, almohadillas suaves",
    "Подарок на каждый день": "Un regalo para cada día",
    "В коробке кабель и чехол, можно дарить сразу": "En la caja, cable y funda: listo para regalar",
    "Для поиска": "Para búsqueda",
    "Наушники беспроводные с шумоподавлением": "Auriculares inalámbricos con cancelación de ruido",
    "Накладные, с микрофоном, складные, для телефона": "Supraaurales, con micrófono, plegables, para el móvil",
    "коротко и по делу": "breve y al grano",
    "Простыми словами": "Con palabras sencillas",
    "простыми словами, без терминов": "con palabras sencillas, sin tecnicismos",
    "Подробно": "Detallado",
    "подробно, с деталями": "con detalle, con ejemplos concretos",
    "Без эмодзи": "Sin emojis",
    "без эмодзи": "sin emojis",
    "Идея": "Idea",
    "О чём промпт? Например: кот-астронавт сидит на Луне и смотрит на Землю": "¿De qué trata el prompt? Por ejemplo: un gato astronauta sentado en la Luna mira la Tierra",
    "Политику и запрещённые темы не пропустим": "No dejaremos pasar política ni temas prohibidos",
    "Ваш промпт": "Tu prompt",
    "Вставьте промпт, который хотите улучшить": "Pega el prompt que quieres mejorar",
    "Название и преимущества": "Nombre y beneficios",
    "Флисовая куртка женская на молнии Плотный мягкий флис Два боковых кармана": "Chaqueta polar de mujer con cremallera\nForro polar denso y suave\nDos bolsillos laterales",
    "Название первой строкой, ниже по преимуществу": "El nombre en la primera línea y debajo una ventaja por línea",
    "Кот-астронавт": "Gato astronauta",
    "Рыжий кот-астронавт сидит на Луне и смотрит на Землю": "Un gato pelirrojo astronauta sentado en la Luna mira la Tierra",
    "Город будущего": "Ciudad del futuro",
    "Ночной город будущего, летающие машины и неоновые вывески": "Una ciudad nocturna del futuro, coches voladores y letreros de neón",
    "Уютное кафе": "Café acogedor",
    "Уютное кафе у окна в дождливое утро": "Un café acogedor junto a la ventana en una mañana lluviosa",
    "Горы на рассвете": "Montañas al amanecer",
    "Горное озеро на рассвете, туман над водой": "Un lago de montaña al amanecer, niebla sobre el agua",
    "Портрет в студии": "Retrato de estudio",
    "Студийный портрет девушки в мягком свете": "Un retrato de estudio de una chica con luz suave",
    "фото": "foto",
    "видео": "vídeo",
    "музыки": "música",
    "текста": "texto",
    "Расшифровка готова": "Transcripción lista",
    "текст не создан": "el texto no se ha creado",
    "Не получилось распознать речь": "No se pudo reconocer el habla",
    "Получаем текст ролика": "Obteniendo el texto del vídeo",
    "Ролик не прошёл проверку": "El vídeo no superó la revisión",
    "Не получилось получить текст": "No se pudo obtener el texto",
    "Заменить ссылку": "Cambiar el enlace",
    "Пишем описание товара": "Escribiendo la descripción del producto",
    "Описание не прошло проверку": "La descripción no superó la revisión",
    "описание не создано": "la descripción no se ha creado",
    "Не получилось написать описание": "No se pudo escribir la descripción",
    "Описание не создано": "La descripción no se ha creado",
    "Фото не прошло проверку": "La foto no superó la revisión",
    "промпт не создан": "el prompt no se ha creado",
    "Не получилось создать промпт": "No se pudo crear el prompt",
    "Промпт не создан": "El prompt no se ha creado",
    "Заменить фото": "Cambiar la foto",
    "Видео не прошло проверку": "El vídeo no pasó la verificación",
    "Заменить видео": "Reemplazar vídeo",
    "Получить текст": "Obtener el texto",
    "Создать описание": "Crear una descripción",
    "за текст ролика": "por el texto del vídeo",
    "за описание": "por descripción",
    "за промпт": "por prompt",
    "за варианты": "por las variantes",
    "Фотореализм": "Fotorrealismo",
    "Кино": "Cine",
    "Аниме": "Anime",
    "Акварель": "Acuarela",
    "Неон": "Neón",
    "Минимализм": "Minimalismo",
    "3D-мультфильм": "Dibujo animado 3D",
    "Документальный": "Documental",
    "Замедление": "Cámara lenta",
    "Эмбиент": "Ambient",
    "Лоу-фай": "Lo-fi",
    "Поп": "Pop",
    "Оркестр": "Orquesta",
    "Синтвейв": "Synthwave",
    "Джаз": "Jazz",
    "Деловой": "Profesional",
    "Ироничный": "Irónico",
    "Научный": "Científico",
    "Поэтичный": "Poético",
    "Кинематографичнее": "Más cinematográfico",
    "Свет и цвет": "Luz y color",
    "Реализм": "Realismo",
    "Движение камеры": "Movimiento de cámara",
    "Жанр и темп": "Género y tempo",
    "Настроение": "Ambiente",
    "Без вокала": "Sin voz",
    "Проще": "Más sencillo",
    "Структура": "Estructura",
    "Тон": "Tono",
    "С примером": "Con un ejemplo"
  },
  "de": {
    "Загрузите запись или видео": "Laden Sie eine Aufnahme oder ein Video hoch",
    "Разговор, интервью, лекция или голосовое": "Ein Gespräch, Interview, Vortrag oder eine Sprachnachricht",
    "Загрузите фото товара": "Laden Sie ein Produktfoto hoch",
    "Необязательно: по фото опишем детали точнее": "Optional: Mit Fotos beschreiben wir die Details genauer",
    "По фото найдём материал, цвет и детали": "Auf den Fotos erkennen wir Material, Farbe und Details",
    "Опишем снимок так, чтобы его можно было повторить": "Wir beschreiben das Bild so, dass es sich nachstellen lässt",
    "Опишем сцену, движение камеры и свет": "Wir beschreiben Szene, Kamerabewegung und Licht",
    "Вставить": "Einfügen",
    "Это не ссылка на ролик YouTube": "Das ist kein Link zu einem YouTube-Video",
    "Ссылка на YouTube": "YouTube-Link",
    "Или ссылка на YouTube": "Oder ein YouTube-Link",
    "Ссылка на ролик YouTube": "Link zu einem YouTube-Video",
    "Весь текст": "Ganzer Text",
    "С временем абзацев": "Mit Zeitangaben der Absätze",
    "Пересказ": "Zusammenfassung",
    "Главное в нескольких абзацах": "Das Wichtigste in wenigen Absätzen",
    "Тезисы": "Kernaussagen",
    "Коротко по пунктам": "Kurz in Stichpunkten",
    "Язык текста": "Sprache des Textes",
    "Исходный": "Original",
    "Подписать собеседников": "Sprecher benennen",
    "Без имён": "Ohne Namen",
    "Время реплик": "Zeit der Wortbeiträge",
    "В начале каждой реплики": "Am Anfang jedes Beitrags",
    "Без времени": "Ohne Zeit",
    "Время в начале каждой реплики": "Zeit am Anfang jedes Beitrags",
    "Я.Маркет": "Y.Market",
    "Общая для товарных инструментов": "Gemeinsam für alle Produkt-Tools",
    "Только для описания": "Nur für die Beschreibung",
    "Например: коротко, простыми словами": "Zum Beispiel: kurz, in einfachen Worten",
    "Стиль промпта": "Prompt-Stil",
    "Одна-две фразы": "Ein, zwei Sätze",
    "Сцена, свет, камера, стиль": "Szene, Licht, Kamera, Stil",
    "По пунктам": "In Stichpunkten",
    "Ключ и значение строками": "Schlüssel und Wert zeilenweise",
    "Язык промпта": "Sprache des Prompts",
    "Стиль текста": "Textstil",
    "Для чего": "Wofür",
    "Жанр или стиль": "Genre oder Stil",
    "Что сделать": "Was zu tun ist",
    "Что именно нужно": "Was genau benötigt wird",
    "Например: вечер, дождь, неон": "Zum Beispiel: Abend, Regen, Neon",
    "Для {0}": "Für {0}",
    "свой вариант": "eigene Variante",
    "Пишем варианты": "Varianten werden geschrieben",
    "Использовать в Фото": "In Foto verwenden",
    "Использовать в Видео": "In Video verwenden",
    "Закончите запись видео": "Beenden Sie die Videoaufnahme",
    "Остановите запись": "Beenden Sie die Aufnahme",
    "Сделайте снимок или закройте камеру": "Machen Sie ein Foto oder schließen Sie die Kamera",
    "Загрузите запись или видео, или вставьте ссылку": "Laden Sie eine Aufnahme oder ein Video hoch oder fügen Sie einen Link ein",
    "Напишите название товара первой строкой": "Schreiben Sie den Produktnamen in die erste Zeile",
    "Текст длиннее {0} знаков": "Der Text ist länger als {0} Zeichen",
    "Пожелания длиннее 300 знаков": "Die Wünsche sind länger als 300 Zeichen",
    "Пожелания длиннее {0} знаков": "Die Wünsche sind länger als {0} Zeichen",
    "Напишите от {0} знаков": "Schreiben Sie mindestens {0} Zeichen",
    "Создать фото по промпту": "Foto aus dem Prompt erstellen",
    "Создать видео по промпту": "Video aus dem Prompt erstellen",
    "Сделать видео товара": "Produktvideo erstellen",
    "Сделать описание товара": "Produktbeschreibung erstellen",
    "Текст выделен: скопируйте его вручную": "Der Text ist markiert: Kopieren Sie ihn manuell",
    "Вставьте ссылку в поле": "Fügen Sie den Link in das Feld ein",
    "Бот уже прислал расшифровку в чат, в отдельную тему.": "Der Bot hat die Transkription bereits in den Chat geschickt, in ein eigenes Thema.",
    "Бот уже прислал текст в чат, в отдельную тему.": "Der Bot hat den Text bereits in den Chat geschickt, in ein eigenes Thema.",
    "Бот уже прислал описание в чат, в отдельную тему.": "Der Bot hat die Beschreibung bereits in den Chat geschickt, in ein eigenes Thema.",
    "Бот уже прислал промпт в чат, в отдельную тему.": "Der Bot hat den Prompt bereits in den Chat geschickt, in ein eigenes Thema.",
    "Бот пришлёт расшифровку в чат, в отдельную тему.": "Der Bot schickt die Transkription in den Chat, in ein eigenes Thema.",
    "Бот пришлёт текст в чат, в отдельную тему.": "Der Bot schickt den Text in den Chat, in ein eigenes Thema.",
    "Бот пришлёт описание в чат, в отдельную тему.": "Der Bot schickt die Beschreibung in den Chat, in ein eigenes Thema.",
    "Бот пришлёт промпт в чат, в отдельную тему.": "Der Bot schickt den Prompt in den Chat, in ein eigenes Thema.",
    "Можно уйти с экрана: бот напишет, когда расшифровка будет готова.": "Sie können den Bildschirm verlassen: Der Bot meldet sich, wenn die Transkription fertig ist.",
    "Можно уйти с экрана: бот напишет, когда текст будет готов.": "Sie können den Bildschirm verlassen: Der Bot meldet sich, wenn der Text fertig ist.",
    "Можно уйти с экрана: бот напишет, когда описание будет готово.": "Sie können den Bildschirm verlassen: Der Bot meldet sich, wenn die Beschreibung fertig ist.",
    "Можно уйти с экрана: бот напишет, когда промпт будет готов.": "Sie können den Bildschirm verlassen: Der Bot meldet sich, wenn der Prompt fertig ist.",
    "Тут откроется тема чата, куда бот прислал расшифровку": "Hier öffnet sich das Chat-Thema, in das der Bot die Transkription geschickt hat",
    "Тут откроется тема чата, куда бот прислал текст": "Hier öffnet sich das Chat-Thema, in das der Bot den Text geschickt hat",
    "Тут откроется тема чата, куда бот прислал описание": "Hier öffnet sich das Chat-Thema, in das der Bot die Beschreibung geschickt hat",
    "Тут откроется тема чата, куда бот прислал промпт": "Hier öffnet sich das Chat-Thema, in das der Bot den Prompt geschickt hat",
    "Не удалось открыть результат.": "Das Ergebnis konnte nicht geöffnet werden.",
    "Сбросить черновик": "Entwurf zurücksetzen",
    "{0}, из длинного выберете {1} секунд": "{0}, aus einem langen wählen Sie {1} Sekunden",
    "Не прошло проверку: политику и запрещённые темы не пропускаем.": "Prüfung nicht bestanden: Politik und verbotene Themen lassen wir nicht zu.",
    "{0} C списаны": "{0} C abgebucht",
    "{0} C вернулись на баланс": "{0} C zurück auf dem Guthaben",
    "Попробуйте ещё раз": "Bitte versuchen Sie es noch einmal",
    "Не удалось открыть варианты.": "Die Varianten konnten nicht geöffnet werden.",
    "Файл загружен": "Datei hochgeladen",
    "Распознаём речь": "Sprache wird erkannt",
    "Речь распознана": "Sprache erkannt",
    "Определяем, кто говорит": "Sprecher werden erkannt",
    "Собеседники подписаны": "Sprecher benannt",
    "Отмечаем время реплик": "Zeiten der Beiträge werden markiert",
    "Время отмечено": "Zeiten markiert",
    "Собираем текст": "Text wird zusammengestellt",
    "Текст собран": "Text zusammengestellt",
    "Получаем ролик": "Video wird abgerufen",
    "Ролик получен": "Video abgerufen",
    "Пишем пересказ": "Zusammenfassung wird geschrieben",
    "Пересказ готов": "Zusammenfassung fertig",
    "Выделяем тезисы": "Kernaussagen werden herausgearbeitet",
    "Тезисы готовы": "Kernaussagen fertig",
    "Проверяем данные": "Daten werden geprüft",
    "Данные проверены": "Daten geprüft",
    "Смотрим фото": "Fotos werden angesehen",
    "Фото изучено": "Fotos angesehen",
    "Пишем описание": "Beschreibung wird geschrieben",
    "Описание готово": "Beschreibung fertig",
    "Подбираем ключевые слова": "Schlüsselwörter werden ausgewählt",
    "Ключевые слова подобраны": "Schlüsselwörter ausgewählt",
    "Смотрим кадр": "Bild wird angesehen",
    "Кадр изучен": "Bild angesehen",
    "Пишем промпт": "Prompt wird geschrieben",
    "Промпт готов": "Prompt fertig",
    "Смотрим ролик": "Video wird angesehen",
    "Ролик изучен": "Video angesehen",
    "Каждый блок копируется отдельно.": "Jeder Block lässt sich einzeln kopieren.",
    "Можно сразу создать по нему фото.": "Sie können daraus sofort ein Foto erstellen.",
    "Нужна запись или видео": "Eine Aufnahme oder ein Video wird benötigt",
    "Нужна аудиозапись": "Eine Audioaufnahme wird benötigt",
    "собеседник": "Sprecher",
    "собеседника": "Sprecher",
    "собеседников": "Sprecher",
    "Показать всё · {0}": "Alles anzeigen · {0}",
    "реплика": "Beitrag",
    "реплики": "Beiträge",
    "реплик": "Beiträge",
    "знак": "Zeichen",
    "знака": "Zeichen",
    "знаков": "Zeichen",
    "пункт": "Punkt",
    "пункта": "Punkte",
    "пунктов": "Punkte",
    "фраза": "Phrase",
    "фразы": "Phrasen",
    "фраз": "Phrasen",
    "Промпт": "Prompt",
    "В записи не нашлось речи": "In der Aufnahme wurde keine Sprache gefunden",
    "Загрузите файл, где слышно, как говорят.": "Laden Sie eine Datei hoch, in der Sprechen zu hören ist.",
    "Заполните, что нужно для создания": "Füllen Sie aus, was zum Erstellen nötig ist",
    "Файл, запись или ссылка на YouTube: текст, кто говорит и время реплик": "Datei, Aufnahme oder YouTube-Link: Text, Sprecher und Zeitangaben",
    "Расшифровка, пересказ или тезисы ролика по ссылке": "Transkription, Zusammenfassung oder Kernaussagen eines Videos per Link",
    "Заголовок, описание и ключевые слова для карточки товара": "Titel, Beschreibung und Schlüsselwörter für die Produktkarte",
    "Промпт из видео": "Prompt aus Video",
    "Опишем сцену, движение камеры и свет ролика": "Wir beschreiben Szene, Kamerabewegung und Licht des Videos",
    "Подробный промпт из короткой идеи": "Ein ausführlicher Prompt aus einer kurzen Idee",
    "Добавим детали, стиль и свет": "Wir ergänzen Details, Stil und Licht",
    "Полный текст": "Volltext",
    "Краткий пересказ": "Kurze Zusammenfassung",
    "Как в ролике": "Wie im Video",
    "Свой сайт": "Eigene Website",
    "Тишина и 40 часов музыки": "Stille und 40 Stunden Musik",
    "Шумоподавление выключает город, заряда хватит на неделю": "Die Geräuschunterdrückung schaltet die Stadt ab, der Akku hält eine Woche",
    "Bluetooth 5.3, ANC до 35 дБ": "Bluetooth 5.3, ANC bis 35 dB",
    "Кодеки AAC и SBC, 10 минут заряда дают 4 часа музыки": "AAC- und SBC-Codecs, 10 Minuten Laden ergeben 4 Stunden Musik",
    "Беспроводные наушники": "Kabellose Kopfhörer",
    "Шумоподавление, до 40 часов работы, мягкие амбушюры": "Geräuschunterdrückung, bis zu 40 Stunden Laufzeit, weiche Ohrpolster",
    "Звук, который слышно в деталях": "Klang, der jedes Detail hören lässt",
    "Эко-кожа, мягкая посадка и тишина вокруг": "Kunstleder, weicher Sitz und Ruhe ringsum",
    "Город станет тише": "Die Stadt wird leiser",
    "Наденьте и слушайте любимое хоть всю неделю": "Aufsetzen und eine ganze Woche Lieblingsmusik hören",
    "Коротко": "Kurz",
    "Тихо. Долго. Удобно": "Leise. Ausdauernd. Bequem",
    "40 часов, шумоподавление, мягкие амбушюры": "40 Stunden, Geräuschunterdrückung, weiche Ohrpolster",
    "Подарок на каждый день": "Ein Geschenk für jeden Tag",
    "В коробке кабель и чехол, можно дарить сразу": "Kabel und Etui im Karton, sofort verschenkbar",
    "Для поиска": "Für die Suche",
    "Наушники беспроводные с шумоподавлением": "Kabellose Kopfhörer mit Geräuschunterdrückung",
    "Накладные, с микрофоном, складные, для телефона": "On-Ear, mit Mikrofon, faltbar, fürs Handy",
    "коротко и по делу": "kurz und auf den Punkt",
    "Простыми словами": "In einfachen Worten",
    "простыми словами, без терминов": "in einfachen Worten, ohne Fachbegriffe",
    "Подробно": "Ausführlich",
    "подробно, с деталями": "ausführlich, mit Details",
    "Без эмодзи": "Ohne Emojis",
    "без эмодзи": "ohne Emojis",
    "Идея": "Idee",
    "О чём промпт? Например: кот-астронавт сидит на Луне и смотрит на Землю": "Worum geht es im Prompt? Zum Beispiel: Eine Astronautenkatze sitzt auf dem Mond und blickt zur Erde",
    "Политику и запрещённые темы не пропустим": "Politik und verbotene Themen lassen wir nicht durch",
    "Ваш промпт": "Ihr Prompt",
    "Вставьте промпт, который хотите улучшить": "Fügen Sie den Prompt ein, den Sie verbessern möchten",
    "Название и преимущества": "Name und Vorteile",
    "Флисовая куртка женская на молнии Плотный мягкий флис Два боковых кармана": "Damen-Fleecejacke mit Reißverschluss\nDichter, weicher Fleece\nZwei Seitentaschen",
    "Название первой строкой, ниже по преимуществу": "Der Name in die erste Zeile, darunter je ein Vorteil",
    "Кот-астронавт": "Astronautenkatze",
    "Рыжий кот-астронавт сидит на Луне и смотрит на Землю": "Eine rote Astronautenkatze sitzt auf dem Mond und blickt zur Erde",
    "Город будущего": "Stadt der Zukunft",
    "Ночной город будущего, летающие машины и неоновые вывески": "Eine nächtliche Stadt der Zukunft, fliegende Autos und Neonschilder",
    "Уютное кафе": "Gemütliches Café",
    "Уютное кафе у окна в дождливое утро": "Ein gemütliches Café am Fenster an einem regnerischen Morgen",
    "Горы на рассвете": "Berge im Morgengrauen",
    "Горное озеро на рассвете, туман над водой": "Ein Bergsee im Morgengrauen, Nebel über dem Wasser",
    "Портрет в студии": "Studioporträt",
    "Студийный портрет девушки в мягком свете": "Ein Studioporträt einer jungen Frau in weichem Licht",
    "фото": "Foto",
    "видео": "Video",
    "музыки": "Musik",
    "текста": "Text",
    "Расшифровка готова": "Transkription fertig",
    "текст не создан": "der Text wurde nicht erstellt",
    "Не получилось распознать речь": "Die Sprache konnte nicht erkannt werden",
    "Получаем текст ролика": "Text des Videos wird abgerufen",
    "Ролик не прошёл проверку": "Das Video hat die Prüfung nicht bestanden",
    "Не получилось получить текст": "Der Text konnte nicht abgerufen werden",
    "Заменить ссылку": "Link ersetzen",
    "Пишем описание товара": "Produktbeschreibung wird geschrieben",
    "Описание не прошло проверку": "Die Beschreibung hat die Prüfung nicht bestanden",
    "описание не создано": "die Beschreibung wurde nicht erstellt",
    "Не получилось написать описание": "Die Beschreibung konnte nicht geschrieben werden",
    "Описание не создано": "Die Beschreibung wurde nicht erstellt",
    "Фото не прошло проверку": "Das Foto hat die Prüfung nicht bestanden",
    "промпт не создан": "der Prompt wurde nicht erstellt",
    "Не получилось создать промпт": "Der Prompt konnte nicht erstellt werden",
    "Промпт не создан": "Der Prompt wurde nicht erstellt",
    "Заменить фото": "Foto ersetzen",
    "Видео не прошло проверку": "Das Video hat die Prüfung nicht bestanden",
    "Заменить видео": "Video ersetzen",
    "Получить текст": "Text erhalten",
    "Создать описание": "Beschreibung erstellen",
    "за текст ролика": "pro Videotext",
    "за описание": "pro Beschreibung",
    "за промпт": "pro Prompt",
    "за варианты": "pro Variantensatz",
    "Фотореализм": "Fotorealismus",
    "Кино": "Kino",
    "Аниме": "Anime",
    "Акварель": "Aquarell",
    "Неон": "Neon",
    "Минимализм": "Minimalismus",
    "3D-мультфильм": "3D-Zeichentrick",
    "Документальный": "Dokumentarisch",
    "Замедление": "Zeitlupe",
    "Эмбиент": "Ambient",
    "Лоу-фай": "Lo-Fi",
    "Поп": "Pop",
    "Оркестр": "Orchester",
    "Синтвейв": "Synthwave",
    "Джаз": "Jazz",
    "Деловой": "Geschäftlich",
    "Ироничный": "Ironisch",
    "Научный": "Wissenschaftlich",
    "Поэтичный": "Poetisch",
    "Кинематографичнее": "Filmischer",
    "Свет и цвет": "Licht und Farbe",
    "Реализм": "Realismus",
    "Движение камеры": "Kamerabewegung",
    "Жанр и темп": "Genre und Tempo",
    "Настроение": "Stimmung",
    "Без вокала": "Ohne Gesang",
    "Проще": "Einfacher",
    "Структура": "Struktur",
    "Тон": "Ton",
    "С примером": "Mit Beispiel"
  },
  "fr": {
    "Загрузите запись или видео": "Importez un enregistrement ou une vidéo",
    "Разговор, интервью, лекция или голосовое": "Une conversation, une interview, un cours ou un message vocal",
    "Загрузите фото товара": "Ajoutez une photo du produit",
    "Необязательно: по фото опишем детали точнее": "Facultatif : avec des photos, nous décrirons les détails plus précisément",
    "По фото найдём материал, цвет и детали": "Sur les photos, nous repérerons la matière, la couleur et les détails",
    "Опишем снимок так, чтобы его можно было повторить": "Nous décrirons la photo de façon à pouvoir la reproduire",
    "Опишем сцену, движение камеры и свет": "Nous décrirons la scène, le mouvement de caméra et la lumière",
    "Вставить": "Coller",
    "Это не ссылка на ролик YouTube": "Ce n’est pas un lien vers une vidéo YouTube",
    "Ссылка на YouTube": "Lien YouTube",
    "Или ссылка на YouTube": "Ou un lien YouTube",
    "Ссылка на ролик YouTube": "Lien vers une vidéo YouTube",
    "Весь текст": "Texte intégral",
    "С временем абзацев": "Avec l’horodatage des paragraphes",
    "Пересказ": "Résumé",
    "Главное в нескольких абзацах": "L’essentiel en quelques paragraphes",
    "Тезисы": "Points clés",
    "Коротко по пунктам": "En bref, point par point",
    "Язык текста": "Langue du texte",
    "Исходный": "Original",
    "Подписать собеседников": "Identifier les interlocuteurs",
    "Без имён": "Sans noms",
    "Время реплик": "Horodatage des répliques",
    "В начале каждой реплики": "Au début de chaque réplique",
    "Без времени": "Sans horodatage",
    "Время в начале каждой реплики": "Horodatage au début de chaque réplique",
    "Я.Маркет": "Y.Market",
    "Общая для товарных инструментов": "Commune aux outils produit",
    "Только для описания": "Pour la description uniquement",
    "Например: коротко, простыми словами": "Par exemple : bref, avec des mots simples",
    "Стиль промпта": "Style du prompt",
    "Одна-две фразы": "Une ou deux phrases",
    "Сцена, свет, камера, стиль": "Scène, lumière, caméra, style",
    "По пунктам": "Point par point",
    "Ключ и значение строками": "Clé et valeur sur chaque ligne",
    "Язык промпта": "Langue du prompt",
    "Стиль текста": "Style du texte",
    "Для чего": "Pour quoi",
    "Жанр или стиль": "Genre ou style",
    "Что сделать": "Que faire",
    "Что именно нужно": "Ce qu’il vous faut exactement",
    "Например: вечер, дождь, неон": "Par exemple : soir, pluie, néon",
    "Для {0}": "Pour {0}",
    "свой вариант": "votre option",
    "Пишем варианты": "Rédaction des variantes",
    "Использовать в Фото": "Utiliser dans Photo",
    "Использовать в Видео": "Utiliser dans Vidéo",
    "Закончите запись видео": "Terminez l’enregistrement de la vidéo",
    "Остановите запись": "Arrêtez l’enregistrement",
    "Сделайте снимок или закройте камеру": "Prenez une photo ou fermez l’appareil",
    "Загрузите запись или видео, или вставьте ссылку": "Importez un enregistrement ou une vidéo, ou collez un lien",
    "Напишите название товара первой строкой": "Écrivez le nom du produit sur la première ligne",
    "Текст длиннее {0} знаков": "Le texte dépasse {0} caractères",
    "Пожелания длиннее 300 знаков": "Les préférences dépassent 300 caractères",
    "Пожелания длиннее {0} знаков": "Les préférences dépassent {0} caractères",
    "Напишите от {0} знаков": "Écrivez au moins {0} caractères",
    "Создать фото по промпту": "Créer une photo à partir du prompt",
    "Создать видео по промпту": "Créer une vidéo à partir du prompt",
    "Сделать видео товара": "Faire une vidéo du produit",
    "Сделать описание товара": "Faire une description du produit",
    "Текст выделен: скопируйте его вручную": "Le texte est sélectionné : copiez-le manuellement",
    "Вставьте ссылку в поле": "Collez le lien dans le champ",
    "Бот уже прислал расшифровку в чат, в отдельную тему.": "Le bot a déjà envoyé la transcription dans le chat, dans un sujet à part.",
    "Бот уже прислал текст в чат, в отдельную тему.": "Le bot a déjà envoyé le texte dans le chat, dans un sujet à part.",
    "Бот уже прислал описание в чат, в отдельную тему.": "Le bot a déjà envoyé la description dans le chat, dans un sujet à part.",
    "Бот уже прислал промпт в чат, в отдельную тему.": "Le bot a déjà envoyé le prompt dans le chat, dans un sujet à part.",
    "Бот пришлёт расшифровку в чат, в отдельную тему.": "Le bot enverra la transcription dans le chat, dans un sujet à part.",
    "Бот пришлёт текст в чат, в отдельную тему.": "Le bot enverra le texte dans le chat, dans un sujet à part.",
    "Бот пришлёт описание в чат, в отдельную тему.": "Le bot enverra la description dans le chat, dans un sujet à part.",
    "Бот пришлёт промпт в чат, в отдельную тему.": "Le bot enverra le prompt dans le chat, dans un sujet à part.",
    "Можно уйти с экрана: бот напишет, когда расшифровка будет готова.": "Vous pouvez quitter l’écran : le bot vous écrira quand la transcription sera prête.",
    "Можно уйти с экрана: бот напишет, когда текст будет готов.": "Vous pouvez quitter l’écran : le bot vous écrira quand le texte sera prêt.",
    "Можно уйти с экрана: бот напишет, когда описание будет готово.": "Vous pouvez quitter l’écran : le bot vous écrira quand la description sera prête.",
    "Можно уйти с экрана: бот напишет, когда промпт будет готов.": "Vous pouvez quitter l’écran : le bot vous écrira quand le prompt sera prêt.",
    "Тут откроется тема чата, куда бот прислал расшифровку": "Ici s’ouvrira le sujet du chat où le bot a envoyé la transcription",
    "Тут откроется тема чата, куда бот прислал текст": "Ici s’ouvrira le sujet du chat où le bot a envoyé le texte",
    "Тут откроется тема чата, куда бот прислал описание": "Ici s’ouvrira le sujet du chat où le bot a envoyé la description",
    "Тут откроется тема чата, куда бот прислал промпт": "Ici s’ouvrira le sujet du chat où le bot a envoyé le prompt",
    "Не удалось открыть результат.": "Impossible d’ouvrir le résultat.",
    "Сбросить черновик": "Réinitialiser le brouillon",
    "{0}, из длинного выберете {1} секунд": "{0}, dans une vidéo longue vous choisirez {1} secondes",
    "Не прошло проверку: политику и запрещённые темы не пропускаем.": "Vérification échouée : nous n’acceptons ni la politique ni les sujets interdits.",
    "{0} C списаны": "{0} C débités",
    "{0} C вернулись на баланс": "{0} C remboursés sur le solde",
    "Попробуйте ещё раз": "Veuillez réessayer",
    "Не удалось открыть варианты.": "Impossible d’ouvrir les variantes.",
    "Файл загружен": "Fichier importé",
    "Распознаём речь": "Reconnaissance de la parole",
    "Речь распознана": "Parole reconnue",
    "Определяем, кто говорит": "Identification des interlocuteurs",
    "Собеседники подписаны": "Interlocuteurs identifiés",
    "Отмечаем время реплик": "Horodatage des répliques",
    "Время отмечено": "Horodatage fait",
    "Собираем текст": "Assemblage du texte",
    "Текст собран": "Texte assemblé",
    "Получаем ролик": "Récupération de la vidéo",
    "Ролик получен": "Vidéo récupérée",
    "Пишем пересказ": "Rédaction du résumé",
    "Пересказ готов": "Résumé prêt",
    "Выделяем тезисы": "Extraction des points clés",
    "Тезисы готовы": "Points clés prêts",
    "Проверяем данные": "Vérification des données",
    "Данные проверены": "Données vérifiées",
    "Смотрим фото": "Examen des photos",
    "Фото изучено": "Photos examinées",
    "Пишем описание": "Rédaction de la description",
    "Описание готово": "Description prête",
    "Подбираем ключевые слова": "Choix des mots-clés",
    "Ключевые слова подобраны": "Mots-clés choisis",
    "Смотрим кадр": "Examen de l’image",
    "Кадр изучен": "Image examinée",
    "Пишем промпт": "Rédaction du prompt",
    "Промпт готов": "Prompt prêt",
    "Смотрим ролик": "Visionnage de la vidéo",
    "Ролик изучен": "Vidéo visionnée",
    "Каждый блок копируется отдельно.": "Chaque bloc se copie séparément.",
    "Можно сразу создать по нему фото.": "Vous pouvez créer une photo à partir de celui-ci tout de suite.",
    "Нужна запись или видео": "Il faut un enregistrement ou une vidéo",
    "Нужна аудиозапись": "Il faut un enregistrement audio",
    "собеседник": "interlocuteur",
    "собеседника": "interlocuteurs",
    "собеседников": "interlocuteurs",
    "Показать всё · {0}": "Tout afficher · {0}",
    "реплика": "réplique",
    "реплики": "répliques",
    "реплик": "répliques",
    "знак": "caractère",
    "знака": "caractères",
    "знаков": "caractères",
    "пункт": "point",
    "пункта": "points",
    "пунктов": "points",
    "фраза": "expression",
    "фразы": "expressions",
    "фраз": "expressions",
    "Промпт": "Prompt",
    "В записи не нашлось речи": "Aucune parole n’a été trouvée dans l’enregistrement",
    "Загрузите файл, где слышно, как говорят.": "Importez un fichier où l’on entend parler.",
    "Заполните, что нужно для создания": "Remplissez ce qu’il faut pour créer",
    "Файл, запись или ссылка на YouTube: текст, кто говорит и время реплик": "Un fichier, un enregistrement ou un lien YouTube : le texte, qui parle et quand",
    "Расшифровка, пересказ или тезисы ролика по ссылке": "Transcription, résumé ou points clés d’une vidéo par lien",
    "Заголовок, описание и ключевые слова для карточки товара": "Titre, description et mots-clés pour la fiche produit",
    "Промпт из видео": "Prompt à partir d’une vidéo",
    "Опишем сцену, движение камеры и свет ролика": "Nous décrirons la scène, le mouvement de caméra et la lumière de la vidéo",
    "Подробный промпт из короткой идеи": "Un prompt détaillé à partir d’une idée courte",
    "Добавим детали, стиль и свет": "Nous ajouterons des détails, du style et de la lumière",
    "Полный текст": "Texte complet",
    "Краткий пересказ": "Résumé court",
    "Как в ролике": "Comme dans la vidéo",
    "Свой сайт": "Site personnel",
    "Тишина и 40 часов музыки": "Le silence et 40 heures de musique",
    "Шумоподавление выключает город, заряда хватит на неделю": "La réduction de bruit éteint la ville, la batterie tient une semaine",
    "Bluetooth 5.3, ANC до 35 дБ": "Bluetooth 5.3, ANC jusqu’à 35 dB",
    "Кодеки AAC и SBC, 10 минут заряда дают 4 часа музыки": "Codecs AAC et SBC, 10 minutes de charge donnent 4 heures de musique",
    "Беспроводные наушники": "Casque sans fil",
    "Шумоподавление, до 40 часов работы, мягкие амбушюры": "Réduction de bruit, jusqu’à 40 heures d’autonomie, coussinets doux",
    "Звук, который слышно в деталях": "Un son qui s’entend dans les moindres détails",
    "Эко-кожа, мягкая посадка и тишина вокруг": "Similicuir, maintien doux et silence autour",
    "Город станет тише": "La ville deviendra plus calme",
    "Наденьте и слушайте любимое хоть всю неделю": "Mettez-le et écoutez vos morceaux préférés toute la semaine",
    "Коротко": "Court",
    "Тихо. Долго. Удобно": "Silencieux. Endurant. Confortable",
    "40 часов, шумоподавление, мягкие амбушюры": "40 heures, réduction de bruit, coussinets doux",
    "Подарок на каждый день": "Un cadeau pour tous les jours",
    "В коробке кабель и чехол, можно дарить сразу": "Câble et étui dans la boîte, prêt à offrir",
    "Для поиска": "Pour la recherche",
    "Наушники беспроводные с шумоподавлением": "Casque sans fil à réduction de bruit",
    "Накладные, с микрофоном, складные, для телефона": "Supra-auriculaire, avec micro, pliable, pour téléphone",
    "коротко и по делу": "bref et précis",
    "Простыми словами": "Avec des mots simples",
    "простыми словами, без терминов": "avec des mots simples, sans jargon",
    "Подробно": "En détail",
    "подробно, с деталями": "en détail, avec des précisions",
    "Без эмодзи": "Sans émojis",
    "без эмодзи": "sans émojis",
    "Идея": "Idée",
    "О чём промпт? Например: кот-астронавт сидит на Луне и смотрит на Землю": "De quoi parle le prompt ? Par exemple : un chat astronaute assis sur la Lune regarde la Terre",
    "Политику и запрещённые темы не пропустим": "Nous ne laisserons passer ni la politique ni les sujets interdits",
    "Ваш промпт": "Votre prompt",
    "Вставьте промпт, который хотите улучшить": "Collez le prompt que vous voulez améliorer",
    "Название и преимущества": "Nom et avantages",
    "Флисовая куртка женская на молнии Плотный мягкий флис Два боковых кармана": "Veste polaire femme zippée\nPolaire dense et douce\nDeux poches latérales",
    "Название первой строкой, ниже по преимуществу": "Le nom sur la première ligne, puis un avantage par ligne",
    "Кот-астронавт": "Chat astronaute",
    "Рыжий кот-астронавт сидит на Луне и смотрит на Землю": "Un chat roux astronaute assis sur la Lune regarde la Terre",
    "Город будущего": "Ville du futur",
    "Ночной город будущего, летающие машины и неоновые вывески": "Une ville du futur la nuit, des voitures volantes et des enseignes néon",
    "Уютное кафе": "Café douillet",
    "Уютное кафе у окна в дождливое утро": "Un café douillet près de la fenêtre par un matin pluvieux",
    "Горы на рассвете": "Montagnes à l’aube",
    "Горное озеро на рассвете, туман над водой": "Un lac de montagne à l’aube, de la brume sur l’eau",
    "Портрет в студии": "Portrait en studio",
    "Студийный портрет девушки в мягком свете": "Un portrait en studio d’une jeune femme sous une lumière douce",
    "фото": "la photo",
    "видео": "vidéo",
    "музыки": "la musique",
    "текста": "le texte",
    "Расшифровка готова": "Transcription prête",
    "текст не создан": "le texte n’a pas été créé",
    "Не получилось распознать речь": "Impossible de reconnaître la parole",
    "Получаем текст ролика": "Récupération du texte de la vidéo",
    "Ролик не прошёл проверку": "La vidéo n’a pas passé la vérification",
    "Не получилось получить текст": "Impossible de récupérer le texte",
    "Заменить ссылку": "Remplacer le lien",
    "Пишем описание товара": "Rédaction de la description du produit",
    "Описание не прошло проверку": "La description n’a pas passé la vérification",
    "описание не создано": "la description n’a pas été créée",
    "Не получилось написать описание": "Impossible de rédiger la description",
    "Описание не создано": "La description n’a pas été créée",
    "Фото не прошло проверку": "La photo n’a pas passé la vérification",
    "промпт не создан": "le prompt n’a pas été créé",
    "Не получилось создать промпт": "Impossible de créer le prompt",
    "Промпт не создан": "Le prompt n’a pas été créé",
    "Заменить фото": "Remplacer la photo",
    "Видео не прошло проверку": "La vidéo n’a pas passé la vérification",
    "Заменить видео": "Remplacer la vidéo",
    "Получить текст": "Obtenir le texte",
    "Создать описание": "Créer une description",
    "за текст ролика": "par texte de vidéo",
    "за описание": "par description",
    "за промпт": "par prompt",
    "за варианты": "par série de variantes",
    "Фотореализм": "Photoréalisme",
    "Кино": "Cinéma",
    "Аниме": "Anime",
    "Акварель": "Aquarelle",
    "Неон": "Néon",
    "Минимализм": "Minimalisme",
    "3D-мультфильм": "Dessin animé 3D",
    "Документальный": "Documentaire",
    "Замедление": "Ralenti",
    "Эмбиент": "Ambient",
    "Лоу-фай": "Lo-fi",
    "Поп": "Pop",
    "Оркестр": "Orchestre",
    "Синтвейв": "Synthwave",
    "Джаз": "Jazz",
    "Деловой": "Professionnel",
    "Ироничный": "Ironique",
    "Научный": "Scientifique",
    "Поэтичный": "Poétique",
    "Кинематографичнее": "Plus cinématographique",
    "Свет и цвет": "Lumière et couleur",
    "Реализм": "Réalisme",
    "Движение камеры": "Mouvement de caméra",
    "Жанр и темп": "Genre et tempo",
    "Настроение": "Ambiance",
    "Без вокала": "Sans voix",
    "Проще": "Plus simple",
    "Структура": "Structure",
    "Тон": "Ton",
    "С примером": "Avec un exemple"
  },
  "pt": {
    "Загрузите запись или видео": "Envie uma gravação ou um vídeo",
    "Разговор, интервью, лекция или голосовое": "Uma conversa, entrevista, palestra ou mensagem de voz",
    "Загрузите фото товара": "Envie uma foto do produto",
    "Необязательно: по фото опишем детали точнее": "Opcional: com fotos descrevemos os detalhes com mais precisão",
    "По фото найдём материал, цвет и детали": "Nas fotos encontraremos o material, a cor e os detalhes",
    "Опишем снимок так, чтобы его можно было повторить": "Descreveremos a foto de forma que possa ser recriada",
    "Опишем сцену, движение камеры и свет": "Descreveremos a cena, o movimento da câmera e a luz",
    "Вставить": "Colar",
    "Это не ссылка на ролик YouTube": "Isto não é um link para um vídeo do YouTube",
    "Ссылка на YouTube": "Link do YouTube",
    "Или ссылка на YouTube": "Ou um link do YouTube",
    "Ссылка на ролик YouTube": "Link para um vídeo do YouTube",
    "Весь текст": "Texto completo",
    "С временем абзацев": "Com o tempo dos parágrafos",
    "Пересказ": "Resumo",
    "Главное в нескольких абзацах": "O principal em alguns parágrafos",
    "Тезисы": "Pontos-chave",
    "Коротко по пунктам": "Resumido, por tópicos",
    "Язык текста": "Idioma do texto",
    "Исходный": "Original",
    "Подписать собеседников": "Identificar os falantes",
    "Без имён": "Sem nomes",
    "Время реплик": "Tempo das falas",
    "В начале каждой реплики": "No início de cada fala",
    "Без времени": "Sem tempo",
    "Время в начале каждой реплики": "Tempo no início de cada fala",
    "Я.Маркет": "Y.Market",
    "Общая для товарных инструментов": "Compartilhada pelas ferramentas de produto",
    "Только для описания": "Apenas para a descrição",
    "Например: коротко, простыми словами": "Por exemplo: breve, com palavras simples",
    "Стиль промпта": "Estilo do prompt",
    "Одна-две фразы": "Uma ou duas frases",
    "Сцена, свет, камера, стиль": "Cena, luz, câmera, estilo",
    "По пунктам": "Por tópicos",
    "Ключ и значение строками": "Chave e valor em cada linha",
    "Язык промпта": "Idioma do prompt",
    "Стиль текста": "Estilo do texto",
    "Для чего": "Para quê",
    "Жанр или стиль": "Gênero ou estilo",
    "Что сделать": "O que fazer",
    "Что именно нужно": "O que exatamente você precisa",
    "Например: вечер, дождь, неон": "Por exemplo: noite, chuva, neon",
    "Для {0}": "Para {0}",
    "свой вариант": "sua opção",
    "Пишем варианты": "Escrevendo variantes",
    "Использовать в Фото": "Usar em Foto",
    "Использовать в Видео": "Usar em Vídeo",
    "Закончите запись видео": "Termine a gravação do vídeo",
    "Остановите запись": "Pare a gravação",
    "Сделайте снимок или закройте камеру": "Tire uma foto ou feche a câmera",
    "Загрузите запись или видео, или вставьте ссылку": "Envie uma gravação ou um vídeo, ou cole um link",
    "Напишите название товара первой строкой": "Escreva o nome do produto na primeira linha",
    "Текст длиннее {0} знаков": "O texto tem mais de {0} caracteres",
    "Пожелания длиннее 300 знаков": "As preferências têm mais de 300 caracteres",
    "Пожелания длиннее {0} знаков": "As preferências têm mais de {0} caracteres",
    "Напишите от {0} знаков": "Escreva pelo menos {0} caracteres",
    "Создать фото по промпту": "Criar uma foto com o prompt",
    "Создать видео по промпту": "Criar um vídeo com o prompt",
    "Сделать видео товара": "Fazer um vídeo do produto",
    "Сделать описание товара": "Fazer uma descrição do produto",
    "Текст выделен: скопируйте его вручную": "O texto está selecionado: copie-o manualmente",
    "Вставьте ссылку в поле": "Cole o link no campo",
    "Бот уже прислал расшифровку в чат, в отдельную тему.": "O bot já enviou a transcrição para o chat, em um tópico separado.",
    "Бот уже прислал текст в чат, в отдельную тему.": "O bot já enviou o texto para o chat, em um tópico separado.",
    "Бот уже прислал описание в чат, в отдельную тему.": "O bot já enviou a descrição para o chat, em um tópico separado.",
    "Бот уже прислал промпт в чат, в отдельную тему.": "O bot já enviou o prompt para o chat, em um tópico separado.",
    "Бот пришлёт расшифровку в чат, в отдельную тему.": "O bot enviará a transcrição para o chat, em um tópico separado.",
    "Бот пришлёт текст в чат, в отдельную тему.": "O bot enviará o texto para o chat, em um tópico separado.",
    "Бот пришлёт описание в чат, в отдельную тему.": "O bot enviará a descrição para o chat, em um tópico separado.",
    "Бот пришлёт промпт в чат, в отдельную тему.": "O bot enviará o prompt para o chat, em um tópico separado.",
    "Можно уйти с экрана: бот напишет, когда расшифровка будет готова.": "Você pode sair da tela: o bot avisará quando a transcrição estiver pronta.",
    "Можно уйти с экрана: бот напишет, когда текст будет готов.": "Você pode sair da tela: o bot avisará quando o texto estiver pronto.",
    "Можно уйти с экрана: бот напишет, когда описание будет готово.": "Você pode sair da tela: o bot avisará quando a descrição estiver pronta.",
    "Можно уйти с экрана: бот напишет, когда промпт будет готов.": "Você pode sair da tela: o bot avisará quando o prompt estiver pronto.",
    "Тут откроется тема чата, куда бот прислал расшифровку": "Aqui abrirá o tópico do chat onde o bot enviou a transcrição",
    "Тут откроется тема чата, куда бот прислал текст": "Aqui abrirá o tópico do chat onde o bot enviou o texto",
    "Тут откроется тема чата, куда бот прислал описание": "Aqui abrirá o tópico do chat onde o bot enviou a descrição",
    "Тут откроется тема чата, куда бот прислал промпт": "Aqui abrirá o tópico do chat onde o bot enviou o prompt",
    "Не удалось открыть результат.": "Não foi possível abrir o resultado.",
    "Сбросить черновик": "Redefinir o rascunho",
    "{0}, из длинного выберете {1} секунд": "{0}, de um longo você escolhe {1} segundos",
    "Не прошло проверку: политику и запрещённые темы не пропускаем.": "Não passou na verificação: não permitimos política nem temas proibidos.",
    "{0} C списаны": "{0} C cobrados",
    "{0} C вернулись на баланс": "{0} C devolvidos ao saldo",
    "Попробуйте ещё раз": "Tente novamente",
    "Не удалось открыть варианты.": "Não foi possível abrir as variantes.",
    "Файл загружен": "Arquivo enviado",
    "Распознаём речь": "Reconhecendo a fala",
    "Речь распознана": "Fala reconhecida",
    "Определяем, кто говорит": "Identificando quem fala",
    "Собеседники подписаны": "Falantes identificados",
    "Отмечаем время реплик": "Marcando o tempo das falas",
    "Время отмечено": "Tempos marcados",
    "Собираем текст": "Montando o texto",
    "Текст собран": "Texto montado",
    "Получаем ролик": "Obtendo o vídeo",
    "Ролик получен": "Vídeo obtido",
    "Пишем пересказ": "Escrevendo o resumo",
    "Пересказ готов": "Resumo pronto",
    "Выделяем тезисы": "Extraindo os pontos-chave",
    "Тезисы готовы": "Pontos-chave prontos",
    "Проверяем данные": "Verificando os dados",
    "Данные проверены": "Dados verificados",
    "Смотрим фото": "Analisando as fotos",
    "Фото изучено": "Fotos analisadas",
    "Пишем описание": "Escrevendo a descrição",
    "Описание готово": "Descrição pronta",
    "Подбираем ключевые слова": "Escolhendo as palavras-chave",
    "Ключевые слова подобраны": "Palavras-chave escolhidas",
    "Смотрим кадр": "Analisando a imagem",
    "Кадр изучен": "Imagem analisada",
    "Пишем промпт": "Escrevendo o prompt",
    "Промпт готов": "Prompt pronto",
    "Смотрим ролик": "Analisando o vídeo",
    "Ролик изучен": "Vídeo analisado",
    "Каждый блок копируется отдельно.": "Cada bloco pode ser copiado separadamente.",
    "Можно сразу создать по нему фото.": "Você pode criar uma foto com ele na hora.",
    "Нужна запись или видео": "É preciso uma gravação ou um vídeo",
    "Нужна аудиозапись": "É preciso uma gravação de áudio",
    "собеседник": "falante",
    "собеседника": "falantes",
    "собеседников": "falantes",
    "Показать всё · {0}": "Mostrar tudo · {0}",
    "реплика": "fala",
    "реплики": "falas",
    "реплик": "falas",
    "знак": "caractere",
    "знака": "caracteres",
    "знаков": "caracteres",
    "пункт": "tópico",
    "пункта": "tópicos",
    "пунктов": "tópicos",
    "фраза": "frase",
    "фразы": "frases",
    "фраз": "frases",
    "Промпт": "Prompt",
    "В записи не нашлось речи": "Nenhuma fala foi encontrada na gravação",
    "Загрузите файл, где слышно, как говорят.": "Envie um arquivo em que dê para ouvir as pessoas falando.",
    "Заполните, что нужно для создания": "Preencha o necessário para criar",
    "Файл, запись или ссылка на YouTube: текст, кто говорит и время реплик": "Um arquivo, uma gravação ou um link do YouTube: o texto, quem fala e quando",
    "Расшифровка, пересказ или тезисы ролика по ссылке": "Transcrição, resumo ou pontos-chave de um vídeo pelo link",
    "Заголовок, описание и ключевые слова для карточки товара": "Título, descrição e palavras-chave para o card do produto",
    "Промпт из видео": "Prompt de um vídeo",
    "Опишем сцену, движение камеры и свет ролика": "Descreveremos a cena, o movimento da câmera e a luz do vídeo",
    "Подробный промпт из короткой идеи": "Um prompt detalhado a partir de uma ideia curta",
    "Добавим детали, стиль и свет": "Adicionaremos detalhes, estilo e luz",
    "Полный текст": "Texto completo",
    "Краткий пересказ": "Resumo breve",
    "Как в ролике": "Como no vídeo",
    "Свой сайт": "Site próprio",
    "Тишина и 40 часов музыки": "Silêncio e 40 horas de música",
    "Шумоподавление выключает город, заряда хватит на неделю": "O cancelamento de ruído desliga a cidade, a bateria dura uma semana",
    "Bluetooth 5.3, ANC до 35 дБ": "Bluetooth 5.3, ANC até 35 dB",
    "Кодеки AAC и SBC, 10 минут заряда дают 4 часа музыки": "Codecs AAC e SBC, 10 minutos de carga rendem 4 horas de música",
    "Беспроводные наушники": "Fones de ouvido sem fio",
    "Шумоподавление, до 40 часов работы, мягкие амбушюры": "Cancelamento de ruído, até 40 horas de bateria, almofadas macias",
    "Звук, который слышно в деталях": "Um som que se ouve em cada detalhe",
    "Эко-кожа, мягкая посадка и тишина вокруг": "Couro ecológico, ajuste macio e silêncio ao redor",
    "Город станет тише": "A cidade vai ficar mais silenciosa",
    "Наденьте и слушайте любимое хоть всю неделю": "Coloque e ouça o que gosta a semana inteira",
    "Коротко": "Curto",
    "Тихо. Долго. Удобно": "Silencioso. Duradouro. Confortável",
    "40 часов, шумоподавление, мягкие амбушюры": "40 horas, cancelamento de ruído, almofadas macias",
    "Подарок на каждый день": "Um presente para todos os dias",
    "В коробке кабель и чехол, можно дарить сразу": "Cabo e estojo na caixa, pronto para presentear",
    "Для поиска": "Para busca",
    "Наушники беспроводные с шумоподавлением": "Fones de ouvido sem fio com cancelamento de ruído",
    "Накладные, с микрофоном, складные, для телефона": "Supra-auriculares, com microfone, dobráveis, para celular",
    "коротко и по делу": "breve e direto ao ponto",
    "Простыми словами": "Com palavras simples",
    "простыми словами, без терминов": "com palavras simples, sem termos técnicos",
    "Подробно": "Detalhado",
    "подробно, с деталями": "detalhado, com especificidades",
    "Без эмодзи": "Sem emojis",
    "без эмодзи": "sem emojis",
    "Идея": "Ideia",
    "О чём промпт? Например: кот-астронавт сидит на Луне и смотрит на Землю": "Sobre o que é o prompt? Por exemplo: um gato astronauta sentado na Lua olha para a Terra",
    "Политику и запрещённые темы не пропустим": "Não deixaremos passar política nem temas proibidos",
    "Ваш промпт": "Seu prompt",
    "Вставьте промпт, который хотите улучшить": "Cole o prompt que você quer melhorar",
    "Название и преимущества": "Nome e benefícios",
    "Флисовая куртка женская на молнии Плотный мягкий флис Два боковых кармана": "Jaqueta de fleece feminina com zíper\nFleece denso e macio\nDois bolsos laterais",
    "Название первой строкой, ниже по преимуществу": "O nome na primeira linha e abaixo uma vantagem por linha",
    "Кот-астронавт": "Gato astronauta",
    "Рыжий кот-астронавт сидит на Луне и смотрит на Землю": "Um gato ruivo astronauta sentado na Lua olha para a Terra",
    "Город будущего": "Cidade do futuro",
    "Ночной город будущего, летающие машины и неоновые вывески": "Uma cidade noturna do futuro, carros voadores e letreiros de neon",
    "Уютное кафе": "Café aconchegante",
    "Уютное кафе у окна в дождливое утро": "Um café aconchegante junto à janela numa manhã chuvosa",
    "Горы на рассвете": "Montanhas ao amanhecer",
    "Горное озеро на рассвете, туман над водой": "Um lago de montanha ao amanhecer, neblina sobre a água",
    "Портрет в студии": "Retrato em estúdio",
    "Студийный портрет девушки в мягком свете": "Um retrato em estúdio de uma jovem em luz suave",
    "фото": "foto",
    "видео": "vídeo",
    "музыки": "música",
    "текста": "texto",
    "Расшифровка готова": "Transcrição pronta",
    "текст не создан": "o texto não foi criado",
    "Не получилось распознать речь": "Não foi possível reconhecer a fala",
    "Получаем текст ролика": "Obtendo o texto do vídeo",
    "Ролик не прошёл проверку": "O vídeo não passou na verificação",
    "Не получилось получить текст": "Não foi possível obter o texto",
    "Заменить ссылку": "Trocar o link",
    "Пишем описание товара": "Escrevendo a descrição do produto",
    "Описание не прошло проверку": "A descrição não passou na verificação",
    "описание не создано": "a descrição não foi criada",
    "Не получилось написать описание": "Não foi possível escrever a descrição",
    "Описание не создано": "A descrição não foi criada",
    "Фото не прошло проверку": "A foto não passou na verificação",
    "промпт не создан": "o prompt não foi criado",
    "Не получилось создать промпт": "Não foi possível criar o prompt",
    "Промпт не создан": "O prompt não foi criado",
    "Заменить фото": "Trocar a foto",
    "Видео не прошло проверку": "O vídeo não passou na verificação",
    "Заменить видео": "Substituir vídeo",
    "Получить текст": "Obter o texto",
    "Создать описание": "Criar uma descrição",
    "за текст ролика": "por texto do vídeo",
    "за описание": "por descrição",
    "за промпт": "por prompt",
    "за варианты": "pelas variantes",
    "Фотореализм": "Fotorrealismo",
    "Кино": "Cinema",
    "Аниме": "Anime",
    "Акварель": "Aquarela",
    "Неон": "Neon",
    "Минимализм": "Minimalismo",
    "3D-мультфильм": "Desenho 3D",
    "Документальный": "Documentário",
    "Замедление": "Câmera lenta",
    "Эмбиент": "Ambient",
    "Лоу-фай": "Lo-fi",
    "Поп": "Pop",
    "Оркестр": "Orquestra",
    "Синтвейв": "Synthwave",
    "Джаз": "Jazz",
    "Деловой": "Profissional",
    "Ироничный": "Irônico",
    "Научный": "Científico",
    "Поэтичный": "Poético",
    "Кинематографичнее": "Mais cinematográfico",
    "Свет и цвет": "Luz e cor",
    "Реализм": "Realismo",
    "Движение камеры": "Movimento de câmera",
    "Жанр и темп": "Gênero e andamento",
    "Настроение": "Clima",
    "Без вокала": "Sem vocal",
    "Проще": "Mais simples",
    "Структура": "Estrutura",
    "Тон": "Tom",
    "С примером": "Com um exemplo"
  },
  "tr": {
    "Загрузите запись или видео": "Bir kayıt veya video yükleyin",
    "Разговор, интервью, лекция или голосовое": "Bir sohbet, röportaj, ders veya sesli mesaj",
    "Загрузите фото товара": "Ürün fotoğrafı yükleyin",
    "Необязательно: по фото опишем детали точнее": "İsteğe bağlı: fotoğraflarla ayrıntıları daha doğru anlatırız",
    "По фото найдём материал, цвет и детали": "Fotoğraflardan malzemeyi, rengi ve ayrıntıları buluruz",
    "Опишем снимок так, чтобы его можно было повторить": "Fotoğrafı yeniden çekilebilecek şekilde anlatırız",
    "Опишем сцену, движение камеры и свет": "Sahneyi, kamera hareketini ve ışığı anlatırız",
    "Вставить": "Yapıştır",
    "Это не ссылка на ролик YouTube": "Bu bir YouTube videosu bağlantısı değil",
    "Ссылка на YouTube": "YouTube bağlantısı",
    "Или ссылка на YouTube": "Ya da bir YouTube bağlantısı",
    "Ссылка на ролик YouTube": "YouTube videosu bağlantısı",
    "Весь текст": "Tam metin",
    "С временем абзацев": "Paragraf zamanlarıyla",
    "Пересказ": "Özet",
    "Главное в нескольких абзацах": "Birkaç paragrafta ana noktalar",
    "Тезисы": "Ana fikirler",
    "Коротко по пунктам": "Kısaca, madde madde",
    "Язык текста": "Metin dili",
    "Исходный": "Orijinal",
    "Подписать собеседников": "Konuşmacıları belirt",
    "Без имён": "İsimsiz",
    "Время реплик": "Replik zamanları",
    "В начале каждой реплики": "Her repliğin başında",
    "Без времени": "Zamansız",
    "Время в начале каждой реплики": "Her repliğin başında zaman",
    "Я.Маркет": "Y.Market",
    "Общая для товарных инструментов": "Ürün araçları için ortak",
    "Только для описания": "Yalnızca açıklama için",
    "Например: коротко, простыми словами": "Örneğin: kısaca, basit kelimelerle",
    "Стиль промпта": "İstem stili",
    "Одна-две фразы": "Bir iki cümle",
    "Сцена, свет, камера, стиль": "Sahne, ışık, kamera, stil",
    "По пунктам": "Madde madde",
    "Ключ и значение строками": "Satır satır anahtar ve değer",
    "Язык промпта": "İstem dili",
    "Стиль текста": "Metin stili",
    "Для чего": "Ne için",
    "Жанр или стиль": "Tür veya stil",
    "Что сделать": "Ne yapılsın",
    "Что именно нужно": "Tam olarak ne gerekiyor",
    "Например: вечер, дождь, неон": "Örneğin: akşam, yağmur, neon",
    "Для {0}": "{0} için",
    "свой вариант": "kendi seçeneğiniz",
    "Пишем варианты": "Varyantlar yazılıyor",
    "Использовать в Фото": "Fotoğraf’ta kullan",
    "Использовать в Видео": "Video’da kullan",
    "Закончите запись видео": "Video kaydını bitirin",
    "Остановите запись": "Kaydı durdurun",
    "Сделайте снимок или закройте камеру": "Fotoğraf çekin ya da kamerayı kapatın",
    "Загрузите запись или видео, или вставьте ссылку": "Bir kayıt veya video yükleyin ya da bağlantı yapıştırın",
    "Напишите название товара первой строкой": "Ürün adını ilk satıra yazın",
    "Текст длиннее {0} знаков": "Metin {0} karakterden uzun",
    "Пожелания длиннее 300 знаков": "Tercihler 300 karakterden uzun",
    "Пожелания длиннее {0} знаков": "Tercihler {0} karakterden uzun",
    "Напишите от {0} знаков": "En az {0} karakter yazın",
    "Создать фото по промпту": "İstemle fotoğraf oluştur",
    "Создать видео по промпту": "İstemle video oluştur",
    "Сделать видео товара": "Ürün videosu yap",
    "Сделать описание товара": "Ürün açıklaması yap",
    "Текст выделен: скопируйте его вручную": "Metin seçildi: elle kopyalayın",
    "Вставьте ссылку в поле": "Bağlantıyı alana yapıştırın",
    "Бот уже прислал расшифровку в чат, в отдельную тему.": "Bot transkripsiyonu sohbete, ayrı bir konuya zaten gönderdi.",
    "Бот уже прислал текст в чат, в отдельную тему.": "Bot metni sohbete, ayrı bir konuya zaten gönderdi.",
    "Бот уже прислал описание в чат, в отдельную тему.": "Bot açıklamayı sohbete, ayrı bir konuya zaten gönderdi.",
    "Бот уже прислал промпт в чат, в отдельную тему.": "Bot istemi sohbete, ayrı bir konuya zaten gönderdi.",
    "Бот пришлёт расшифровку в чат, в отдельную тему.": "Bot transkripsiyonu sohbete, ayrı bir konuya gönderecek.",
    "Бот пришлёт текст в чат, в отдельную тему.": "Bot metni sohbete, ayrı bir konuya gönderecek.",
    "Бот пришлёт описание в чат, в отдельную тему.": "Bot açıklamayı sohbete, ayrı bir konuya gönderecek.",
    "Бот пришлёт промпт в чат, в отдельную тему.": "Bot istemi sohbete, ayrı bir konuya gönderecek.",
    "Можно уйти с экрана: бот напишет, когда расшифровка будет готова.": "Ekrandan çıkabilirsiniz: transkripsiyon hazır olunca bot yazacak.",
    "Можно уйти с экрана: бот напишет, когда текст будет готов.": "Ekrandan çıkabilirsiniz: metin hazır olunca bot yazacak.",
    "Можно уйти с экрана: бот напишет, когда описание будет готово.": "Ekrandan çıkabilirsiniz: açıklama hazır olunca bot yazacak.",
    "Можно уйти с экрана: бот напишет, когда промпт будет готов.": "Ekrandan çıkabilirsiniz: istem hazır olunca bot yazacak.",
    "Тут откроется тема чата, куда бот прислал расшифровку": "Burada botun transkripsiyonu gönderdiği sohbet konusu açılacak",
    "Тут откроется тема чата, куда бот прислал текст": "Burada botun metni gönderdiği sohbet konusu açılacak",
    "Тут откроется тема чата, куда бот прислал описание": "Burada botun açıklamayı gönderdiği sohbet konusu açılacak",
    "Тут откроется тема чата, куда бот прислал промпт": "Burada botun istemi gönderdiği sohbet konusu açılacak",
    "Не удалось открыть результат.": "Sonuç açılamadı.",
    "Сбросить черновик": "Taslağı sıfırla",
    "{0}, из длинного выберете {1} секунд": "{0}, uzun olandan {1} saniye seçersiniz",
    "Не прошло проверку: политику и запрещённые темы не пропускаем.": "Kontrolden geçmedi: siyaset ve yasaklı konulara izin vermiyoruz.",
    "{0} C списаны": "{0} C düşüldü",
    "{0} C вернулись на баланс": "{0} C bakiyeye iade edildi",
    "Попробуйте ещё раз": "Lütfen tekrar deneyin",
    "Не удалось открыть варианты.": "Varyantlar açılamadı.",
    "Файл загружен": "Dosya yüklendi",
    "Распознаём речь": "Konuşma tanınıyor",
    "Речь распознана": "Konuşma tanındı",
    "Определяем, кто говорит": "Konuşanlar belirleniyor",
    "Собеседники подписаны": "Konuşmacılar belirtildi",
    "Отмечаем время реплик": "Replik zamanları işaretleniyor",
    "Время отмечено": "Zamanlar işaretlendi",
    "Собираем текст": "Metin derleniyor",
    "Текст собран": "Metin derlendi",
    "Получаем ролик": "Video alınıyor",
    "Ролик получен": "Video alındı",
    "Пишем пересказ": "Özet yazılıyor",
    "Пересказ готов": "Özet hazır",
    "Выделяем тезисы": "Ana fikirler çıkarılıyor",
    "Тезисы готовы": "Ana fikirler hazır",
    "Проверяем данные": "Veriler kontrol ediliyor",
    "Данные проверены": "Veriler kontrol edildi",
    "Смотрим фото": "Fotoğraflar inceleniyor",
    "Фото изучено": "Fotoğraflar incelendi",
    "Пишем описание": "Açıklama yazılıyor",
    "Описание готово": "Açıklama hazır",
    "Подбираем ключевые слова": "Anahtar kelimeler seçiliyor",
    "Ключевые слова подобраны": "Anahtar kelimeler seçildi",
    "Смотрим кадр": "Kare inceleniyor",
    "Кадр изучен": "Kare incelendi",
    "Пишем промпт": "İstem yazılıyor",
    "Промпт готов": "İstem hazır",
    "Смотрим ролик": "Video izleniyor",
    "Ролик изучен": "Video incelendi",
    "Каждый блок копируется отдельно.": "Her blok ayrı ayrı kopyalanabilir.",
    "Можно сразу создать по нему фото.": "Onunla hemen fotoğraf oluşturabilirsiniz.",
    "Нужна запись или видео": "Bir kayıt veya video gerekiyor",
    "Нужна аудиозапись": "Bir ses kaydı gerekiyor",
    "собеседник": "konuşmacı",
    "собеседника": "konuşmacı",
    "собеседников": "konuşmacı",
    "Показать всё · {0}": "Tümünü göster · {0}",
    "реплика": "replik",
    "реплики": "replik",
    "реплик": "replik",
    "знак": "karakter",
    "знака": "karakter",
    "знаков": "karakter",
    "пункт": "madde",
    "пункта": "madde",
    "пунктов": "madde",
    "фраза": "ifade",
    "фразы": "ifade",
    "фраз": "ifade",
    "Промпт": "İstem",
    "В записи не нашлось речи": "Kayıtta konuşma bulunamadı",
    "Загрузите файл, где слышно, как говорят.": "Konuşmanın duyulduğu bir dosya yükleyin.",
    "Заполните, что нужно для создания": "Oluşturmak için gerekenleri doldurun",
    "Файл, запись или ссылка на YouTube: текст, кто говорит и время реплик": "Dosya, kayıt veya YouTube bağlantısı: metin, kim konuşuyor ve ne zaman",
    "Расшифровка, пересказ или тезисы ролика по ссылке": "Bağlantıdaki videonun transkripsiyonu, özeti veya ana fikirleri",
    "Заголовок, описание и ключевые слова для карточки товара": "Ürün kartı için başlık, açıklama ve anahtar kelimeler",
    "Промпт из видео": "Videodan istem",
    "Опишем сцену, движение камеры и свет ролика": "Videonun sahnesini, kamera hareketini ve ışığını anlatırız",
    "Подробный промпт из короткой идеи": "Kısa bir fikirden ayrıntılı istem",
    "Добавим детали, стиль и свет": "Ayrıntı, stil ve ışık ekleriz",
    "Полный текст": "Tam metin",
    "Краткий пересказ": "Kısa özet",
    "Как в ролике": "Videodaki gibi",
    "Свой сайт": "Kendi siteniz",
    "Тишина и 40 часов музыки": "Sessizlik ve 40 saat müzik",
    "Шумоподавление выключает город, заряда хватит на неделю": "Gürültü engelleme şehri susturur, şarj bir hafta yeter",
    "Bluetooth 5.3, ANC до 35 дБ": "Bluetooth 5.3, 35 dB’ye kadar ANC",
    "Кодеки AAC и SBC, 10 минут заряда дают 4 часа музыки": "AAC ve SBC kodekleri, 10 dakika şarj 4 saat müzik verir",
    "Беспроводные наушники": "Kablosuz kulaklık",
    "Шумоподавление, до 40 часов работы, мягкие амбушюры": "Gürültü engelleme, 40 saate kadar pil, yumuşak kulak yastıkları",
    "Звук, который слышно в деталях": "Her ayrıntısı duyulan ses",
    "Эко-кожа, мягкая посадка и тишина вокруг": "Eko deri, yumuşak oturuş ve etrafta sessizlik",
    "Город станет тише": "Şehir daha sessiz olacak",
    "Наденьте и слушайте любимое хоть всю неделю": "Takın ve sevdiklerinizi bütün hafta dinleyin",
    "Коротко": "Kısa",
    "Тихо. Долго. Удобно": "Sessiz. Uzun ömürlü. Rahat",
    "40 часов, шумоподавление, мягкие амбушюры": "40 saat, gürültü engelleme, yumuşak kulak yastıkları",
    "Подарок на каждый день": "Her gün için bir hediye",
    "В коробке кабель и чехол, можно дарить сразу": "Kutuda kablo ve kılıf var, hemen hediye edilebilir",
    "Для поиска": "Arama için",
    "Наушники беспроводные с шумоподавлением": "Gürültü engellemeli kablosuz kulaklık",
    "Накладные, с микрофоном, складные, для телефона": "Kulak üstü, mikrofonlu, katlanabilir, telefon için",
    "коротко и по делу": "kısa ve öz",
    "Простыми словами": "Basit kelimelerle",
    "простыми словами, без терминов": "basit kelimelerle, terimsiz",
    "Подробно": "Ayrıntılı",
    "подробно, с деталями": "ayrıntılı, detaylarla",
    "Без эмодзи": "Emojisiz",
    "без эмодзи": "emojisiz",
    "Идея": "Fikir",
    "О чём промпт? Например: кот-астронавт сидит на Луне и смотрит на Землю": "İstem ne hakkında? Örneğin: astronot bir kedi Ay’da oturup Dünya’ya bakıyor",
    "Политику и запрещённые темы не пропустим": "Siyasete ve yasaklı konulara izin vermeyiz",
    "Ваш промпт": "İsteminiz",
    "Вставьте промпт, который хотите улучшить": "İyileştirmek istediğiniz istemi yapıştırın",
    "Название и преимущества": "Ad ve avantajlar",
    "Флисовая куртка женская на молнии Плотный мягкий флис Два боковых кармана": "Kadın fermuarlı polar ceket\nYoğun yumuşak polar\nİki yan cep",
    "Название первой строкой, ниже по преимуществу": "İlk satıra ad, altına her satıra bir avantaj",
    "Кот-астронавт": "Astronot kedi",
    "Рыжий кот-астронавт сидит на Луне и смотрит на Землю": "Kızıl bir astronot kedi Ay’da oturup Dünya’ya bakıyor",
    "Город будущего": "Geleceğin şehri",
    "Ночной город будущего, летающие машины и неоновые вывески": "Geleceğin gece şehri, uçan arabalar ve neon tabelalar",
    "Уютное кафе": "Şirin kafe",
    "Уютное кафе у окна в дождливое утро": "Yağmurlu bir sabah pencere kenarında şirin bir kafe",
    "Горы на рассвете": "Şafakta dağlar",
    "Горное озеро на рассвете, туман над водой": "Şafakta bir dağ gölü, suyun üzerinde sis",
    "Портрет в студии": "Stüdyo portresi",
    "Студийный портрет девушки в мягком свете": "Yumuşak ışıkta bir kızın stüdyo portresi",
    "фото": "fotoğraf",
    "видео": "video",
    "музыки": "müzik",
    "текста": "metin",
    "Расшифровка готова": "Transkripsiyon hazır",
    "текст не создан": "metin oluşturulmadı",
    "Не получилось распознать речь": "Konuşma tanınamadı",
    "Получаем текст ролика": "Videonun metni alınıyor",
    "Ролик не прошёл проверку": "Video kontrolden geçmedi",
    "Не получилось получить текст": "Metin alınamadı",
    "Заменить ссылку": "Bağlantıyı değiştir",
    "Пишем описание товара": "Ürün açıklaması yazılıyor",
    "Описание не прошло проверку": "Açıklama kontrolden geçmedi",
    "описание не создано": "açıklama oluşturulmadı",
    "Не получилось написать описание": "Açıklama yazılamadı",
    "Описание не создано": "Açıklama oluşturulmadı",
    "Фото не прошло проверку": "Fotoğraf kontrolden geçmedi",
    "промпт не создан": "istem oluşturulmadı",
    "Не получилось создать промпт": "İstem oluşturulamadı",
    "Промпт не создан": "İstem oluşturulmadı",
    "Заменить фото": "Fotoğrafı değiştir",
    "Видео не прошло проверку": "Video kontrolden geçmedi",
    "Заменить видео": "Videoyu değiştir",
    "Получить текст": "Metni al",
    "Создать описание": "Açıklama oluştur",
    "за текст ролика": "video metni başına",
    "за описание": "açıklama başına",
    "за промпт": "istem başına",
    "за варианты": "varyantlar için",
    "Фотореализм": "Fotogerçekçilik",
    "Кино": "Sinema",
    "Аниме": "Anime",
    "Акварель": "Suluboya",
    "Неон": "Neon",
    "Минимализм": "Minimalizm",
    "3D-мультфильм": "3D çizgi film",
    "Документальный": "Belgesel",
    "Замедление": "Ağır çekim",
    "Эмбиент": "Ambient",
    "Лоу-фай": "Lo-fi",
    "Поп": "Pop",
    "Оркестр": "Orkestra",
    "Синтвейв": "Synthwave",
    "Джаз": "Caz",
    "Деловой": "Resmi",
    "Ироничный": "İronik",
    "Научный": "Bilimsel",
    "Поэтичный": "Şiirsel",
    "Кинематографичнее": "Daha sinematik",
    "Свет и цвет": "Işık ve renk",
    "Реализм": "Gerçekçilik",
    "Движение камеры": "Kamera hareketi",
    "Жанр и темп": "Tür ve tempo",
    "Настроение": "Ruh hali",
    "Без вокала": "Vokalsiz",
    "Проще": "Daha basit",
    "Структура": "Yapı",
    "Тон": "Ton",
    "С примером": "Örnekli"
  },
  "kk": {
    "Загрузите запись или видео": "Жазбаны немесе видеоны жүктеңіз",
    "Разговор, интервью, лекция или голосовое": "Әңгіме, сұхбат, дәріс немесе дауыстық хабар",
    "Загрузите фото товара": "Тауар фотосын жүктеңіз",
    "Необязательно: по фото опишем детали точнее": "Міндетті емес: фото бойынша бөлшектерді дәлірек сипаттаймыз",
    "По фото найдём материал, цвет и детали": "Фото бойынша материалын, түсін және бөлшектерін табамыз",
    "Опишем снимок так, чтобы его можно было повторить": "Суретті қайталауға болатындай етіп сипаттаймыз",
    "Опишем сцену, движение камеры и свет": "Көріністі, камера қозғалысын және жарықты сипаттаймыз",
    "Вставить": "Қою",
    "Это не ссылка на ролик YouTube": "Бұл YouTube бейнесінің сілтемесі емес",
    "Ссылка на YouTube": "YouTube сілтемесі",
    "Или ссылка на YouTube": "Немесе YouTube сілтемесі",
    "Ссылка на ролик YouTube": "YouTube бейнесінің сілтемесі",
    "Весь текст": "Толық мәтін",
    "С временем абзацев": "Абзацтардың уақытымен",
    "Пересказ": "Мазмұндама",
    "Главное в нескольких абзацах": "Негізгісі бірнеше абзацта",
    "Тезисы": "Тезистер",
    "Коротко по пунктам": "Қысқаша, тармақтар бойынша",
    "Язык текста": "Мәтін тілі",
    "Исходный": "Түпнұсқа",
    "Подписать собеседников": "Сөйлеушілерді белгілеу",
    "Без имён": "Атаусыз",
    "Время реплик": "Реплика уақыты",
    "В начале каждой реплики": "Әр репликаның басында",
    "Без времени": "Уақытсыз",
    "Время в начале каждой реплики": "Әр репликаның басында уақыт",
    "Я.Маркет": "Я.Маркет",
    "Общая для товарных инструментов": "Тауар құралдарына ортақ",
    "Только для описания": "Тек сипаттама үшін",
    "Например: коротко, простыми словами": "Мысалы: қысқаша, қарапайым сөздермен",
    "Стиль промпта": "Промпт стилі",
    "Одна-две фразы": "Бір-екі сөйлем",
    "Сцена, свет, камера, стиль": "Көрініс, жарық, камера, стиль",
    "По пунктам": "Тармақтар бойынша",
    "Ключ и значение строками": "Кілт пен мән жол бойынша",
    "Язык промпта": "Промпт тілі",
    "Стиль текста": "Мәтін стилі",
    "Для чего": "Не үшін",
    "Жанр или стиль": "Жанр немесе стиль",
    "Что сделать": "Не істеу керек",
    "Что именно нужно": "Нақты не керек",
    "Например: вечер, дождь, неон": "Мысалы: кеш, жаңбыр, неон",
    "Для {0}": "{0} үшін",
    "свой вариант": "өз нұсқаңыз",
    "Пишем варианты": "Нұсқаларды жазып жатырмыз",
    "Использовать в Фото": "Фотода пайдалану",
    "Использовать в Видео": "Бейнеде пайдалану",
    "Закончите запись видео": "Видео жазуды аяқтаңыз",
    "Остановите запись": "Жазуды тоқтатыңыз",
    "Сделайте снимок или закройте камеру": "Суретке түсіріңіз немесе камераны жабыңыз",
    "Загрузите запись или видео, или вставьте ссылку": "Жазбаны немесе видеоны жүктеңіз не сілтемені қойыңыз",
    "Напишите название товара первой строкой": "Тауар атауын бірінші жолға жазыңыз",
    "Текст длиннее {0} знаков": "Мәтін {0} таңбадан ұзын",
    "Пожелания длиннее 300 знаков": "Тілектер 300 таңбадан ұзын",
    "Пожелания длиннее {0} знаков": "Тілектер {0} таңбадан ұзын",
    "Напишите от {0} знаков": "Кемінде {0} таңба жазыңыз",
    "Создать фото по промпту": "Промпт бойынша фото жасау",
    "Создать видео по промпту": "Промпт бойынша видео жасау",
    "Сделать видео товара": "Тауар видеосын жасау",
    "Сделать описание товара": "Тауар сипаттамасын жасау",
    "Текст выделен: скопируйте его вручную": "Мәтін белгіленді: оны қолмен көшіріңіз",
    "Вставьте ссылку в поле": "Сілтемені өріске қойыңыз",
    "Бот уже прислал расшифровку в чат, в отдельную тему.": "Бот транскрипцияны чатқа, бөлек тақырыпқа жіберіп қойды.",
    "Бот уже прислал текст в чат, в отдельную тему.": "Бот мәтінді чатқа, бөлек тақырыпқа жіберіп қойды.",
    "Бот уже прислал описание в чат, в отдельную тему.": "Бот сипаттаманы чатқа, бөлек тақырыпқа жіберіп қойды.",
    "Бот уже прислал промпт в чат, в отдельную тему.": "Бот промптты чатқа, бөлек тақырыпқа жіберіп қойды.",
    "Бот пришлёт расшифровку в чат, в отдельную тему.": "Бот транскрипцияны чатқа, бөлек тақырыпқа жібереді.",
    "Бот пришлёт текст в чат, в отдельную тему.": "Бот мәтінді чатқа, бөлек тақырыпқа жібереді.",
    "Бот пришлёт описание в чат, в отдельную тему.": "Бот сипаттаманы чатқа, бөлек тақырыпқа жібереді.",
    "Бот пришлёт промпт в чат, в отдельную тему.": "Бот промптты чатқа, бөлек тақырыпқа жібереді.",
    "Можно уйти с экрана: бот напишет, когда расшифровка будет готова.": "Экраннан шығуға болады: транскрипция дайын болғанда бот жазады.",
    "Можно уйти с экрана: бот напишет, когда текст будет готов.": "Экраннан шығуға болады: мәтін дайын болғанда бот жазады.",
    "Можно уйти с экрана: бот напишет, когда описание будет готово.": "Экраннан шығуға болады: сипаттама дайын болғанда бот жазады.",
    "Можно уйти с экрана: бот напишет, когда промпт будет готов.": "Экраннан шығуға болады: промпт дайын болғанда бот жазады.",
    "Тут откроется тема чата, куда бот прислал расшифровку": "Мұнда бот транскрипцияны жіберген чат тақырыбы ашылады",
    "Тут откроется тема чата, куда бот прислал текст": "Мұнда бот мәтінді жіберген чат тақырыбы ашылады",
    "Тут откроется тема чата, куда бот прислал описание": "Мұнда бот сипаттаманы жіберген чат тақырыбы ашылады",
    "Тут откроется тема чата, куда бот прислал промпт": "Мұнда бот промптты жіберген чат тақырыбы ашылады",
    "Не удалось открыть результат.": "Нәтижені ашу мүмкін болмады.",
    "Сбросить черновик": "Жобаны тастау",
    "{0}, из длинного выберете {1} секунд": "{0}, ұзынынан {1} секунд таңдайсыз",
    "Не прошло проверку: политику и запрещённые темы не пропускаем.": "Тексеруден өтпеді: саясат пен тыйым салынған тақырыптарды өткізбейміз.",
    "{0} C списаны": "{0} C есептен шығарылды",
    "{0} C вернулись на баланс": "{0} C балансқа қайтарылды",
    "Попробуйте ещё раз": "Қайталап көріңіз",
    "Не удалось открыть варианты.": "Нұсқаларды ашу мүмкін болмады.",
    "Файл загружен": "Файл жүктелді",
    "Распознаём речь": "Сөзді танып жатырмыз",
    "Речь распознана": "Сөз танылды",
    "Определяем, кто говорит": "Кім сөйлейтінін анықтап жатырмыз",
    "Собеседники подписаны": "Сөйлеушілер белгіленді",
    "Отмечаем время реплик": "Реплика уақытын белгілеп жатырмыз",
    "Время отмечено": "Уақыт белгіленді",
    "Собираем текст": "Мәтінді жинап жатырмыз",
    "Текст собран": "Мәтін жиналды",
    "Получаем ролик": "Бейнені алып жатырмыз",
    "Ролик получен": "Бейне алынды",
    "Пишем пересказ": "Мазмұндаманы жазып жатырмыз",
    "Пересказ готов": "Мазмұндама дайын",
    "Выделяем тезисы": "Тезистерді бөліп жатырмыз",
    "Тезисы готовы": "Тезистер дайын",
    "Проверяем данные": "Деректерді тексеріп жатырмыз",
    "Данные проверены": "Деректер тексерілді",
    "Смотрим фото": "Фотоларды қарап жатырмыз",
    "Фото изучено": "Фотолар қаралды",
    "Пишем описание": "Сипаттаманы жазып жатырмыз",
    "Описание готово": "Сипаттама дайын",
    "Подбираем ключевые слова": "Түйінді сөздерді таңдап жатырмыз",
    "Ключевые слова подобраны": "Түйінді сөздер таңдалды",
    "Смотрим кадр": "Кадрды қарап жатырмыз",
    "Кадр изучен": "Кадр қаралды",
    "Пишем промпт": "Промптты жазып жатырмыз",
    "Промпт готов": "Промпт дайын",
    "Смотрим ролик": "Бейнені қарап жатырмыз",
    "Ролик изучен": "Бейне қаралды",
    "Каждый блок копируется отдельно.": "Әр блок бөлек көшіріледі.",
    "Можно сразу создать по нему фото.": "Ол бойынша бірден фото жасауға болады.",
    "Нужна запись или видео": "Жазба немесе видео керек",
    "Нужна аудиозапись": "Аудиожазба керек",
    "собеседник": "сөйлеуші",
    "собеседника": "сөйлеуші",
    "собеседников": "сөйлеуші",
    "Показать всё · {0}": "Барлығын көрсету · {0}",
    "реплика": "реплика",
    "реплики": "реплика",
    "реплик": "реплика",
    "знак": "таңба",
    "знака": "таңба",
    "знаков": "таңба",
    "пункт": "тармақ",
    "пункта": "тармақ",
    "пунктов": "тармақ",
    "фраза": "тіркес",
    "фразы": "тіркес",
    "фраз": "тіркес",
    "Промпт": "Промпт",
    "В записи не нашлось речи": "Жазбадан сөз табылмады",
    "Загрузите файл, где слышно, как говорят.": "Сөйлеген дауыс естілетін файлды жүктеңіз.",
    "Заполните, что нужно для создания": "Жасауға қажеттісін толтырыңыз",
    "Файл, запись или ссылка на YouTube: текст, кто говорит и время реплик": "Файл, жазба немесе YouTube сілтемесі: мәтін, кім сөйлейді және қашан",
    "Расшифровка, пересказ или тезисы ролика по ссылке": "Сілтеме бойынша бейненің транскрипциясы, мазмұндамасы немесе тезистері",
    "Заголовок, описание и ключевые слова для карточки товара": "Тауар карточкасына тақырып, сипаттама және түйінді сөздер",
    "Промпт из видео": "Видеодан промпт",
    "Опишем сцену, движение камеры и свет ролика": "Бейненің көрінісін, камера қозғалысын және жарығын сипаттаймыз",
    "Подробный промпт из короткой идеи": "Қысқа идеядан толық промпт",
    "Добавим детали, стиль и свет": "Бөлшектер, стиль және жарық қосамыз",
    "Полный текст": "Толық мәтін",
    "Краткий пересказ": "Қысқаша мазмұндама",
    "Как в ролике": "Бейнедегідей",
    "Свой сайт": "Өз сайтыңыз",
    "Тишина и 40 часов музыки": "Тыныштық және 40 сағат музыка",
    "Шумоподавление выключает город, заряда хватит на неделю": "Шуды басу қаланы өшіреді, заряд бір аптаға жетеді",
    "Bluetooth 5.3, ANC до 35 дБ": "Bluetooth 5.3, 35 дБ дейін ANC",
    "Кодеки AAC и SBC, 10 минут заряда дают 4 часа музыки": "AAC және SBC кодектері, 10 минут зарядтау 4 сағат музыка береді",
    "Беспроводные наушники": "Сымсыз құлаққап",
    "Шумоподавление, до 40 часов работы, мягкие амбушюры": "Шуды басу, 40 сағатқа дейін жұмыс, жұмсақ жастықшалар",
    "Звук, который слышно в деталях": "Әр егжей-тегжейі естілетін дыбыс",
    "Эко-кожа, мягкая посадка и тишина вокруг": "Эко-былғары, жұмсақ отыру және айналада тыныштық",
    "Город станет тише": "Қала тынышырақ болады",
    "Наденьте и слушайте любимое хоть всю неделю": "Киіп алып, сүйікті әуендерді бір апта бойы тыңдаңыз",
    "Коротко": "Қысқа",
    "Тихо. Долго. Удобно": "Тыныш. Ұзақ. Ыңғайлы",
    "40 часов, шумоподавление, мягкие амбушюры": "40 сағат, шуды басу, жұмсақ жастықшалар",
    "Подарок на каждый день": "Күн сайынғы сыйлық",
    "В коробке кабель и чехол, можно дарить сразу": "Қорапта кабель мен қап бар, бірден сыйлауға болады",
    "Для поиска": "Іздеу үшін",
    "Наушники беспроводные с шумоподавлением": "Шуды басатын сымсыз құлаққаптар",
    "Накладные, с микрофоном, складные, для телефона": "Жапсырмалы, микрофонды, бүктелетін, телефонға арналған",
    "коротко и по делу": "қысқа әрі нақты",
    "Простыми словами": "Қарапайым сөздермен",
    "простыми словами, без терминов": "қарапайым сөздермен, терминсіз",
    "Подробно": "Толық",
    "подробно, с деталями": "толық, егжей-тегжейімен",
    "Без эмодзи": "Эмодзисіз",
    "без эмодзи": "эмодзисіз",
    "Идея": "Идея",
    "О чём промпт? Например: кот-астронавт сидит на Луне и смотрит на Землю": "Промпт не туралы? Мысалы: ғарышкер мысық Айда отырып, Жерге қарап отыр",
    "Политику и запрещённые темы не пропустим": "Саясат пен тыйым салынған тақырыптарды өткізбейміз",
    "Ваш промпт": "Сіздің промптыңыз",
    "Вставьте промпт, который хотите улучшить": "Жақсартқыңыз келетін промптты қойыңыз",
    "Название и преимущества": "Атауы және артықшылықтары",
    "Флисовая куртка женская на молнии Плотный мягкий флис Два боковых кармана": "Әйелдердің сырма ілгекті флис күртешесі\nТығыз жұмсақ флис\nЕкі бүйір қалта",
    "Название первой строкой, ниже по преимуществу": "Бірінші жолға атауы, төменде бір-бір артықшылықтан",
    "Кот-астронавт": "Ғарышкер мысық",
    "Рыжий кот-астронавт сидит на Луне и смотрит на Землю": "Жирен ғарышкер мысық Айда отырып, Жерге қарап отыр",
    "Город будущего": "Болашақ қаласы",
    "Ночной город будущего, летающие машины и неоновые вывески": "Болашақтың түнгі қаласы, ұшатын көліктер мен неон жарнамалар",
    "Уютное кафе": "Жайлы кафе",
    "Уютное кафе у окна в дождливое утро": "Жаңбырлы таңда терезе жанындағы жайлы кафе",
    "Горы на рассвете": "Таң атқандағы таулар",
    "Горное озеро на рассвете, туман над водой": "Таң атқандағы тау көлі, су бетінде тұман",
    "Портрет в студии": "Студиядағы портрет",
    "Студийный портрет девушки в мягком свете": "Жұмсақ жарықтағы қыздың студиялық портреті",
    "фото": "фото",
    "видео": "бейне",
    "музыки": "музыка",
    "текста": "мәтін",
    "Расшифровка готова": "Транскрипция дайын",
    "текст не создан": "мәтін жасалмады",
    "Не получилось распознать речь": "Сөзді тану мүмкін болмады",
    "Получаем текст ролика": "Бейне мәтінін алып жатырмыз",
    "Ролик не прошёл проверку": "Бейне тексеруден өтпеді",
    "Не получилось получить текст": "Мәтінді алу мүмкін болмады",
    "Заменить ссылку": "Сілтемені ауыстыру",
    "Пишем описание товара": "Тауар сипаттамасын жазып жатырмыз",
    "Описание не прошло проверку": "Сипаттама тексеруден өтпеді",
    "описание не создано": "сипаттама жасалмады",
    "Не получилось написать описание": "Сипаттаманы жазу мүмкін болмады",
    "Описание не создано": "Сипаттама жасалмады",
    "Фото не прошло проверку": "Фото тексеруден өтпеді",
    "промпт не создан": "промпт жасалмады",
    "Не получилось создать промпт": "Промптты жасау мүмкін болмады",
    "Промпт не создан": "Промпт жасалмады",
    "Заменить фото": "Фотоны ауыстыру",
    "Видео не прошло проверку": "Бейне тексеруден өтпеді",
    "Заменить видео": "Бейнені ауыстыру",
    "Получить текст": "Мәтінді алу",
    "Создать описание": "Сипаттама жасау",
    "за текст ролика": "бейне мәтіні үшін",
    "за описание": "сипаттама үшін",
    "за промпт": "промпт үшін",
    "за варианты": "нұсқалар үшін",
    "Фотореализм": "Фотореализм",
    "Кино": "Кино",
    "Аниме": "Аниме",
    "Акварель": "Акварель",
    "Неон": "Неон",
    "Минимализм": "Минимализм",
    "3D-мультфильм": "3D мультфильм",
    "Документальный": "Деректі",
    "Замедление": "Баяулату",
    "Эмбиент": "Эмбиент",
    "Лоу-фай": "Лоу-фай",
    "Поп": "Поп",
    "Оркестр": "Оркестр",
    "Синтвейв": "Синтвейв",
    "Джаз": "Джаз",
    "Деловой": "Іскерлік",
    "Ироничный": "Әжуалы",
    "Научный": "Ғылыми",
    "Поэтичный": "Поэтикалық",
    "Кинематографичнее": "Кинематографиялығырақ",
    "Свет и цвет": "Жарық пен түс",
    "Реализм": "Реализм",
    "Движение камеры": "Камера қозғалысы",
    "Жанр и темп": "Жанр мен қарқын",
    "Настроение": "Көңіл-күй",
    "Без вокала": "Вокалсыз",
    "Проще": "Қарапайымырақ",
    "Структура": "Құрылым",
    "Тон": "Тон",
    "С примером": "Мысалмен"
  },
  "uk": {
    "Загрузите запись или видео": "Завантажте запис або відео",
    "Разговор, интервью, лекция или голосовое": "Розмова, інтерв’ю, лекція або голосове",
    "Загрузите фото товара": "Завантажте фото товару",
    "Необязательно: по фото опишем детали точнее": "Необов’язково: за фото опишемо деталі точніше",
    "По фото найдём материал, цвет и детали": "За фото знайдемо матеріал, колір і деталі",
    "Опишем снимок так, чтобы его можно было повторить": "Опишемо знімок так, щоб його можна було повторити",
    "Опишем сцену, движение камеры и свет": "Опишемо сцену, рух камери та світло",
    "Вставить": "Вставити",
    "Это не ссылка на ролик YouTube": "Це не посилання на відео YouTube",
    "Ссылка на YouTube": "Посилання на YouTube",
    "Или ссылка на YouTube": "Або посилання на YouTube",
    "Ссылка на ролик YouTube": "Посилання на відео YouTube",
    "Весь текст": "Увесь текст",
    "С временем абзацев": "З часом абзаців",
    "Пересказ": "Переказ",
    "Главное в нескольких абзацах": "Головне в кількох абзацах",
    "Тезисы": "Тези",
    "Коротко по пунктам": "Коротко за пунктами",
    "Язык текста": "Мова тексту",
    "Исходный": "Вихідна",
    "Подписать собеседников": "Підписати співрозмовників",
    "Без имён": "Без імен",
    "Время реплик": "Час реплік",
    "В начале каждой реплики": "На початку кожної репліки",
    "Без времени": "Без часу",
    "Время в начале каждой реплики": "Час на початку кожної репліки",
    "Я.Маркет": "Я.Маркет",
    "Общая для товарных инструментов": "Спільна для товарних інструментів",
    "Только для описания": "Лише для опису",
    "Например: коротко, простыми словами": "Наприклад: коротко, простими словами",
    "Стиль промпта": "Стиль промпту",
    "Одна-две фразы": "Одна-дві фрази",
    "Сцена, свет, камера, стиль": "Сцена, світло, камера, стиль",
    "По пунктам": "За пунктами",
    "Ключ и значение строками": "Ключ і значення рядками",
    "Язык промпта": "Мова промпту",
    "Стиль текста": "Стиль тексту",
    "Для чего": "Для чого",
    "Жанр или стиль": "Жанр або стиль",
    "Что сделать": "Що зробити",
    "Что именно нужно": "Що саме потрібно",
    "Например: вечер, дождь, неон": "Наприклад: вечір, дощ, неон",
    "Для {0}": "Для {0}",
    "свой вариант": "свій варіант",
    "Пишем варианты": "Пишемо варіанти",
    "Использовать в Фото": "Використати у Фото",
    "Использовать в Видео": "Використати у Відео",
    "Закончите запись видео": "Завершіть запис відео",
    "Остановите запись": "Зупиніть запис",
    "Сделайте снимок или закройте камеру": "Зробіть знімок або закрийте камеру",
    "Загрузите запись или видео, или вставьте ссылку": "Завантажте запис або відео чи вставте посилання",
    "Напишите название товара первой строкой": "Напишіть назву товару першим рядком",
    "Текст длиннее {0} знаков": "Текст довший за {0} знаків",
    "Пожелания длиннее 300 знаков": "Побажання довші за 300 знаків",
    "Пожелания длиннее {0} знаков": "Побажання довші за {0} знаків",
    "Напишите от {0} знаков": "Напишіть щонайменше {0} знаків",
    "Создать фото по промпту": "Створити фото за промптом",
    "Создать видео по промпту": "Створити відео за промптом",
    "Сделать видео товара": "Зробити відео товару",
    "Сделать описание товара": "Зробити опис товару",
    "Текст выделен: скопируйте его вручную": "Текст виділено: скопіюйте його вручну",
    "Вставьте ссылку в поле": "Вставте посилання в поле",
    "Бот уже прислал расшифровку в чат, в отдельную тему.": "Бот уже надіслав розшифрування в чат, в окрему тему.",
    "Бот уже прислал текст в чат, в отдельную тему.": "Бот уже надіслав текст у чат, в окрему тему.",
    "Бот уже прислал описание в чат, в отдельную тему.": "Бот уже надіслав опис у чат, в окрему тему.",
    "Бот уже прислал промпт в чат, в отдельную тему.": "Бот уже надіслав промпт у чат, в окрему тему.",
    "Бот пришлёт расшифровку в чат, в отдельную тему.": "Бот надішле розшифрування в чат, в окрему тему.",
    "Бот пришлёт текст в чат, в отдельную тему.": "Бот надішле текст у чат, в окрему тему.",
    "Бот пришлёт описание в чат, в отдельную тему.": "Бот надішле опис у чат, в окрему тему.",
    "Бот пришлёт промпт в чат, в отдельную тему.": "Бот надішле промпт у чат, в окрему тему.",
    "Можно уйти с экрана: бот напишет, когда расшифровка будет готова.": "Можна піти з екрана: бот напише, коли розшифрування буде готове.",
    "Можно уйти с экрана: бот напишет, когда текст будет готов.": "Можна піти з екрана: бот напише, коли текст буде готовий.",
    "Можно уйти с экрана: бот напишет, когда описание будет готово.": "Можна піти з екрана: бот напише, коли опис буде готовий.",
    "Можно уйти с экрана: бот напишет, когда промпт будет готов.": "Можна піти з екрана: бот напише, коли промпт буде готовий.",
    "Тут откроется тема чата, куда бот прислал расшифровку": "Тут відкриється тема чату, куди бот надіслав розшифрування",
    "Тут откроется тема чата, куда бот прислал текст": "Тут відкриється тема чату, куди бот надіслав текст",
    "Тут откроется тема чата, куда бот прислал описание": "Тут відкриється тема чату, куди бот надіслав опис",
    "Тут откроется тема чата, куда бот прислал промпт": "Тут відкриється тема чату, куди бот надіслав промпт",
    "Не удалось открыть результат.": "Не вдалося відкрити результат.",
    "Сбросить черновик": "Скинути чернетку",
    "{0}, из длинного выберете {1} секунд": "{0}, з довгого виберете {1} секунд",
    "Не прошло проверку: политику и запрещённые темы не пропускаем.": "Не пройшло перевірку: політику та заборонені теми не пропускаємо.",
    "{0} C списаны": "{0} C списано",
    "{0} C вернулись на баланс": "{0} C повернулися на баланс",
    "Попробуйте ещё раз": "Спробуйте ще раз",
    "Не удалось открыть варианты.": "Не вдалося відкрити варіанти.",
    "Файл загружен": "Файл завантажено",
    "Распознаём речь": "Розпізнаємо мовлення",
    "Речь распознана": "Мовлення розпізнано",
    "Определяем, кто говорит": "Визначаємо, хто говорить",
    "Собеседники подписаны": "Співрозмовників підписано",
    "Отмечаем время реплик": "Позначаємо час реплік",
    "Время отмечено": "Час позначено",
    "Собираем текст": "Збираємо текст",
    "Текст собран": "Текст зібрано",
    "Получаем ролик": "Отримуємо відео",
    "Ролик получен": "Відео отримано",
    "Пишем пересказ": "Пишемо переказ",
    "Пересказ готов": "Переказ готовий",
    "Выделяем тезисы": "Виділяємо тези",
    "Тезисы готовы": "Тези готові",
    "Проверяем данные": "Перевіряємо дані",
    "Данные проверены": "Дані перевірено",
    "Смотрим фото": "Переглядаємо фото",
    "Фото изучено": "Фото вивчено",
    "Пишем описание": "Пишемо опис",
    "Описание готово": "Опис готовий",
    "Подбираем ключевые слова": "Добираємо ключові слова",
    "Ключевые слова подобраны": "Ключові слова дібрано",
    "Смотрим кадр": "Переглядаємо кадр",
    "Кадр изучен": "Кадр вивчено",
    "Пишем промпт": "Пишемо промпт",
    "Промпт готов": "Промпт готовий",
    "Смотрим ролик": "Переглядаємо відео",
    "Ролик изучен": "Відео вивчено",
    "Каждый блок копируется отдельно.": "Кожен блок копіюється окремо.",
    "Можно сразу создать по нему фото.": "За ним одразу можна створити фото.",
    "Нужна запись или видео": "Потрібен запис або відео",
    "Нужна аудиозапись": "Потрібен аудіозапис",
    "собеседник": "співрозмовник",
    "собеседника": "співрозмовники",
    "собеседников": "співрозмовників",
    "Показать всё · {0}": "Показати все · {0}",
    "реплика": "репліка",
    "реплики": "репліки",
    "реплик": "реплік",
    "знак": "знак",
    "знака": "знаки",
    "знаков": "знаків",
    "пункт": "пункт",
    "пункта": "пункти",
    "пунктов": "пунктів",
    "фраза": "фраза",
    "фразы": "фрази",
    "фраз": "фраз",
    "Промпт": "Промпт",
    "В записи не нашлось речи": "У записі не знайшлося мовлення",
    "Загрузите файл, где слышно, как говорят.": "Завантажте файл, де чутно, як говорять.",
    "Заполните, что нужно для создания": "Заповніть, що потрібно для створення",
    "Файл, запись или ссылка на YouTube: текст, кто говорит и время реплик": "Файл, запис або посилання на YouTube: текст, хто говорить і час реплік",
    "Расшифровка, пересказ или тезисы ролика по ссылке": "Розшифрування, переказ або тези відео за посиланням",
    "Заголовок, описание и ключевые слова для карточки товара": "Заголовок, опис і ключові слова для картки товару",
    "Промпт из видео": "Промпт із відео",
    "Опишем сцену, движение камеры и свет ролика": "Опишемо сцену, рух камери та світло відео",
    "Подробный промпт из короткой идеи": "Докладний промпт із короткої ідеї",
    "Добавим детали, стиль и свет": "Додамо деталі, стиль і світло",
    "Полный текст": "Повний текст",
    "Краткий пересказ": "Короткий переказ",
    "Как в ролике": "Як у відео",
    "Свой сайт": "Власний сайт",
    "Тишина и 40 часов музыки": "Тиша й 40 годин музики",
    "Шумоподавление выключает город, заряда хватит на неделю": "Шумозаглушення вимикає місто, заряду вистачить на тиждень",
    "Bluetooth 5.3, ANC до 35 дБ": "Bluetooth 5.3, ANC до 35 дБ",
    "Кодеки AAC и SBC, 10 минут заряда дают 4 часа музыки": "Кодеки AAC і SBC, 10 хвилин заряджання дають 4 години музики",
    "Беспроводные наушники": "Бездротові навушники",
    "Шумоподавление, до 40 часов работы, мягкие амбушюры": "Шумозаглушення, до 40 годин роботи, м’які амбушури",
    "Звук, который слышно в деталях": "Звук, який чути в деталях",
    "Эко-кожа, мягкая посадка и тишина вокруг": "Екошкіра, м’яка посадка й тиша довкола",
    "Город станет тише": "Місто стане тихішим",
    "Наденьте и слушайте любимое хоть всю неделю": "Одягніть і слухайте улюблене хоч цілий тиждень",
    "Коротко": "Коротко",
    "Тихо. Долго. Удобно": "Тихо. Довго. Зручно",
    "40 часов, шумоподавление, мягкие амбушюры": "40 годин, шумозаглушення, м’які амбушури",
    "Подарок на каждый день": "Подарунок на кожен день",
    "В коробке кабель и чехол, можно дарить сразу": "У коробці кабель і чохол, можна дарувати одразу",
    "Для поиска": "Для пошуку",
    "Наушники беспроводные с шумоподавлением": "Навушники бездротові із шумозаглушенням",
    "Накладные, с микрофоном, складные, для телефона": "Накладні, з мікрофоном, складані, для телефона",
    "коротко и по делу": "коротко й по суті",
    "Простыми словами": "Простими словами",
    "простыми словами, без терминов": "простими словами, без термінів",
    "Подробно": "Докладно",
    "подробно, с деталями": "докладно, з деталями",
    "Без эмодзи": "Без емодзі",
    "без эмодзи": "без емодзі",
    "Идея": "Ідея",
    "О чём промпт? Например: кот-астронавт сидит на Луне и смотрит на Землю": "Про що промпт? Наприклад: кіт-астронавт сидить на Місяці й дивиться на Землю",
    "Политику и запрещённые темы не пропустим": "Політику та заборонені теми не пропустимо",
    "Ваш промпт": "Ваш промпт",
    "Вставьте промпт, который хотите улучшить": "Вставте промпт, який хочете покращити",
    "Название и преимущества": "Назва і переваги",
    "Флисовая куртка женская на молнии Плотный мягкий флис Два боковых кармана": "Флісова куртка жіноча на блискавці\nЩільний м’який фліс\nДві бічні кишені",
    "Название первой строкой, ниже по преимуществу": "Назва першим рядком, нижче — по перевазі",
    "Кот-астронавт": "Кіт-астронавт",
    "Рыжий кот-астронавт сидит на Луне и смотрит на Землю": "Рудий кіт-астронавт сидить на Місяці й дивиться на Землю",
    "Город будущего": "Місто майбутнього",
    "Ночной город будущего, летающие машины и неоновые вывески": "Нічне місто майбутнього, летючі машини та неонові вивіски",
    "Уютное кафе": "Затишне кафе",
    "Уютное кафе у окна в дождливое утро": "Затишне кафе біля вікна дощового ранку",
    "Горы на рассвете": "Гори на світанку",
    "Горное озеро на рассвете, туман над водой": "Гірське озеро на світанку, туман над водою",
    "Портрет в студии": "Портрет у студії",
    "Студийный портрет девушки в мягком свете": "Студійний портрет дівчини в м’якому світлі",
    "фото": "фото",
    "видео": "відео",
    "музыки": "музики",
    "текста": "тексту",
    "Расшифровка готова": "Розшифрування готове",
    "текст не создан": "текст не створено",
    "Не получилось распознать речь": "Не вдалося розпізнати мовлення",
    "Получаем текст ролика": "Отримуємо текст відео",
    "Ролик не прошёл проверку": "Відео не пройшло перевірку",
    "Не получилось получить текст": "Не вдалося отримати текст",
    "Заменить ссылку": "Замінити посилання",
    "Пишем описание товара": "Пишемо опис товару",
    "Описание не прошло проверку": "Опис не пройшов перевірку",
    "описание не создано": "опис не створено",
    "Не получилось написать описание": "Не вдалося написати опис",
    "Описание не создано": "Опис не створено",
    "Фото не прошло проверку": "Фото не пройшло перевірку",
    "промпт не создан": "промпт не створено",
    "Не получилось создать промпт": "Не вдалося створити промпт",
    "Промпт не создан": "Промпт не створено",
    "Заменить фото": "Замінити фото",
    "Видео не прошло проверку": "Відео не пройшло перевірку",
    "Заменить видео": "Замінити відео",
    "Получить текст": "Отримати текст",
    "Создать описание": "Створити опис",
    "за текст ролика": "за текст відео",
    "за описание": "за опис",
    "за промпт": "за промпт",
    "за варианты": "за варіанти",
    "Фотореализм": "Фотореалізм",
    "Кино": "Кіно",
    "Аниме": "Аніме",
    "Акварель": "Акварель",
    "Неон": "Неон",
    "Минимализм": "Мінімалізм",
    "3D-мультфильм": "3D-мультфільм",
    "Документальный": "Документальний",
    "Замедление": "Уповільнення",
    "Эмбиент": "Ембієнт",
    "Лоу-фай": "Лоу-фай",
    "Поп": "Поп",
    "Оркестр": "Оркестр",
    "Синтвейв": "Синтвейв",
    "Джаз": "Джаз",
    "Деловой": "Діловий",
    "Ироничный": "Іронічний",
    "Научный": "Науковий",
    "Поэтичный": "Поетичний",
    "Кинематографичнее": "Кінематографічніше",
    "Свет и цвет": "Світло й колір",
    "Реализм": "Реалізм",
    "Движение камеры": "Рух камери",
    "Жанр и темп": "Жанр і темп",
    "Настроение": "Настрій",
    "Без вокала": "Без вокалу",
    "Проще": "Простіше",
    "Структура": "Структура",
    "Тон": "Тон",
    "С примером": "З прикладом"
  },
  "zh": {
    "Загрузите запись или видео": "上传录音或视频",
    "Разговор, интервью, лекция или голосовое": "对话、采访、讲座或语音消息",
    "Загрузите фото товара": "上传商品照片",
    "Необязательно: по фото опишем детали точнее": "可选：有照片能把细节描述得更准确",
    "По фото найдём материал, цвет и детали": "根据照片识别材质、颜色和细节",
    "Опишем снимок так, чтобы его можно было повторить": "描述这张照片，让它可以被复刻",
    "Опишем сцену, движение камеры и свет": "描述场景、运镜和光线",
    "Вставить": "粘贴",
    "Это не ссылка на ролик YouTube": "这不是 YouTube 视频链接",
    "Ссылка на YouTube": "YouTube 链接",
    "Или ссылка на YouTube": "或 YouTube 链接",
    "Ссылка на ролик YouTube": "YouTube 视频链接",
    "Весь текст": "全文",
    "С временем абзацев": "带段落时间",
    "Пересказ": "摘要",
    "Главное в нескольких абзацах": "用几段话讲清要点",
    "Тезисы": "要点",
    "Коротко по пунктам": "简要分条",
    "Язык текста": "文本语言",
    "Исходный": "原语言",
    "Подписать собеседников": "标注说话人",
    "Без имён": "不标姓名",
    "Время реплик": "台词时间",
    "В начале каждой реплики": "每句台词开头",
    "Без времени": "不标时间",
    "Время в начале каждой реплики": "每句台词开头标注时间",
    "Я.Маркет": "Yandex Market",
    "Общая для товарных инструментов": "商品类工具共用",
    "Только для описания": "仅用于描述",
    "Например: коротко, простыми словами": "例如：简短，用通俗的话",
    "Стиль промпта": "提示词风格",
    "Одна-две фразы": "一两句话",
    "Сцена, свет, камера, стиль": "场景、光线、镜头、风格",
    "По пунктам": "分条",
    "Ключ и значение строками": "每行一个键和值",
    "Язык промпта": "提示词语言",
    "Стиль текста": "文本风格",
    "Для чего": "用途",
    "Жанр или стиль": "类型或风格",
    "Что сделать": "要做什么",
    "Что именно нужно": "具体需要什么",
    "Например: вечер, дождь, неон": "例如：傍晚、下雨、霓虹",
    "Для {0}": "用于 {0}",
    "свой вариант": "自定义",
    "Пишем варианты": "正在撰写版本",
    "Использовать в Фото": "用于照片",
    "Использовать в Видео": "用于视频",
    "Закончите запись видео": "请先结束视频录制",
    "Остановите запись": "请停止录音",
    "Сделайте снимок или закройте камеру": "拍一张或关闭相机",
    "Загрузите запись или видео, или вставьте ссылку": "上传录音或视频，或粘贴链接",
    "Напишите название товара первой строкой": "第一行写商品名称",
    "Текст длиннее {0} знаков": "文字超过 {0} 个字符",
    "Пожелания длиннее 300 знаков": "要求超过 300 字",
    "Пожелания длиннее {0} знаков": "要求超过 {0} 字",
    "Напишите от {0} знаков": "至少写 {0} 个字",
    "Создать фото по промпту": "根据提示词生成照片",
    "Создать видео по промпту": "根据提示词生成视频",
    "Сделать видео товара": "制作商品视频",
    "Сделать описание товара": "制作商品描述",
    "Текст выделен: скопируйте его вручную": "文本已选中：请手动复制",
    "Вставьте ссылку в поле": "请把链接粘贴到输入框",
    "Бот уже прислал расшифровку в чат, в отдельную тему.": "机器人已把转写稿发到聊天的单独话题中。",
    "Бот уже прислал текст в чат, в отдельную тему.": "机器人已把文本发到聊天的单独话题中。",
    "Бот уже прислал описание в чат, в отдельную тему.": "机器人已把描述发到聊天的单独话题中。",
    "Бот уже прислал промпт в чат, в отдельную тему.": "机器人已把提示词发到聊天的单独话题中。",
    "Бот пришлёт расшифровку в чат, в отдельную тему.": "机器人会把转写稿发到聊天的单独话题中。",
    "Бот пришлёт текст в чат, в отдельную тему.": "机器人会把文本发到聊天的单独话题中。",
    "Бот пришлёт описание в чат, в отдельную тему.": "机器人会把描述发到聊天的单独话题中。",
    "Бот пришлёт промпт в чат, в отдельную тему.": "机器人会把提示词发到聊天的单独话题中。",
    "Можно уйти с экрана: бот напишет, когда расшифровка будет готова.": "可以离开此页面：转写稿完成后机器人会通知你。",
    "Можно уйти с экрана: бот напишет, когда текст будет готов.": "可以离开此页面：文本完成后机器人会通知你。",
    "Можно уйти с экрана: бот напишет, когда описание будет готово.": "可以离开此页面：描述完成后机器人会通知你。",
    "Можно уйти с экрана: бот напишет, когда промпт будет готов.": "可以离开此页面：提示词完成后机器人会通知你。",
    "Тут откроется тема чата, куда бот прислал расшифровку": "这里会打开机器人发送转写稿的聊天话题",
    "Тут откроется тема чата, куда бот прислал текст": "这里会打开机器人发送文本的聊天话题",
    "Тут откроется тема чата, куда бот прислал описание": "这里会打开机器人发送描述的聊天话题",
    "Тут откроется тема чата, куда бот прислал промпт": "这里会打开机器人发送提示词的聊天话题",
    "Не удалось открыть результат.": "无法打开结果。",
    "Сбросить черновик": "重置草稿",
    "{0}, из длинного выберете {1} секунд": "{0}，较长的视频可从中选取 {1} 秒",
    "Не прошло проверку: политику и запрещённые темы не пропускаем.": "未通过审核：不接受政治和违禁话题。",
    "{0} C списаны": "已扣除 {0} C",
    "{0} C вернулись на баланс": "{0} C 已退回余额",
    "Попробуйте ещё раз": "请重试",
    "Не удалось открыть варианты.": "无法打开版本。",
    "Файл загружен": "文件已上传",
    "Распознаём речь": "正在识别语音",
    "Речь распознана": "语音已识别",
    "Определяем, кто говорит": "正在识别说话人",
    "Собеседники подписаны": "说话人已标注",
    "Отмечаем время реплик": "正在标注台词时间",
    "Время отмечено": "时间已标注",
    "Собираем текст": "正在整理文本",
    "Текст собран": "文本已整理",
    "Получаем ролик": "正在获取视频",
    "Ролик получен": "视频已获取",
    "Пишем пересказ": "正在撰写摘要",
    "Пересказ готов": "摘要已完成",
    "Выделяем тезисы": "正在提炼要点",
    "Тезисы готовы": "要点已完成",
    "Проверяем данные": "正在检查数据",
    "Данные проверены": "数据已检查",
    "Смотрим фото": "正在查看照片",
    "Фото изучено": "照片已分析",
    "Пишем описание": "正在撰写描述",
    "Описание готово": "描述已完成",
    "Подбираем ключевые слова": "正在挑选关键词",
    "Ключевые слова подобраны": "关键词已选好",
    "Смотрим кадр": "正在查看画面",
    "Кадр изучен": "画面已分析",
    "Пишем промпт": "正在撰写提示词",
    "Промпт готов": "提示词已完成",
    "Смотрим ролик": "正在观看视频",
    "Ролик изучен": "视频已分析",
    "Каждый блок копируется отдельно.": "每个区块可单独复制。",
    "Можно сразу создать по нему фото.": "可以直接用它生成照片。",
    "Нужна запись или видео": "需要录音或视频",
    "Нужна аудиозапись": "需要音频录音",
    "собеседник": "位说话人",
    "собеседника": "位说话人",
    "собеседников": "位说话人",
    "Показать всё · {0}": "显示全部 · {0}",
    "реплика": "句台词",
    "реплики": "句台词",
    "реплик": "句台词",
    "знак": "个字",
    "знака": "个字",
    "знаков": "个字",
    "пункт": "条",
    "пункта": "条",
    "пунктов": "条",
    "фраза": "句话",
    "фразы": "句话",
    "фраз": "句话",
    "Промпт": "提示词",
    "В записи не нашлось речи": "录音中没有检测到语音",
    "Загрузите файл, где слышно, как говорят.": "请上传能听到有人说话的文件。",
    "Заполните, что нужно для создания": "填写创建所需的内容",
    "Файл, запись или ссылка на YouTube: текст, кто говорит и время реплик": "文件、录音或 YouTube 链接：文本、说话人和台词时间",
    "Расшифровка, пересказ или тезисы ролика по ссылке": "根据链接生成视频的转写稿、摘要或要点",
    "Заголовок, описание и ключевые слова для карточки товара": "商品卡片的标题、描述和关键词",
    "Промпт из видео": "从视频生成提示词",
    "Опишем сцену, движение камеры и свет ролика": "描述视频的场景、运镜和光线",
    "Подробный промпт из короткой идеи": "从简短想法生成详细提示词",
    "Добавим детали, стиль и свет": "补充细节、风格和光线",
    "Полный текст": "完整文本",
    "Краткий пересказ": "简短摘要",
    "Как в ролике": "与视频一致",
    "Свой сайт": "自己的网站",
    "Тишина и 40 часов музыки": "安静，以及 40 小时音乐",
    "Шумоподавление выключает город, заряда хватит на неделю": "降噪让城市安静下来，一次充电够用一周",
    "Bluetooth 5.3, ANC до 35 дБ": "蓝牙 5.3，ANC 降噪最高 35 dB",
    "Кодеки AAC и SBC, 10 минут заряда дают 4 часа музыки": "支持 AAC 和 SBC 编码，充电 10 分钟可听 4 小时",
    "Беспроводные наушники": "无线耳机",
    "Шумоподавление, до 40 часов работы, мягкие амбушюры": "降噪，最长 40 小时续航，柔软耳罩",
    "Звук, который слышно в деталях": "听得见每个细节的声音",
    "Эко-кожа, мягкая посадка и тишина вокруг": "环保皮革，佩戴柔软，周围一片安静",
    "Город станет тише": "城市会变得更安静",
    "Наденьте и слушайте любимое хоть всю неделю": "戴上它，喜欢的音乐听上一整周",
    "Коротко": "简短",
    "Тихо. Долго. Удобно": "安静。持久。舒适",
    "40 часов, шумоподавление, мягкие амбушюры": "40 小时、降噪、柔软耳罩",
    "Подарок на каждый день": "适合每天的礼物",
    "В коробке кабель и чехол, можно дарить сразу": "盒内附线缆和收纳包，可直接送人",
    "Для поиска": "用于搜索",
    "Наушники беспроводные с шумоподавлением": "主动降噪无线耳机",
    "Накладные, с микрофоном, складные, для телефона": "头戴式，带麦克风，可折叠，适用于手机",
    "коротко и по делу": "简短直接",
    "Простыми словами": "通俗易懂",
    "простыми словами, без терминов": "通俗易懂，不用术语",
    "Подробно": "详细",
    "подробно, с деталями": "详细，包含细节",
    "Без эмодзи": "不用表情符号",
    "без эмодзи": "不用表情符号",
    "Идея": "创意",
    "О чём промпт? Например: кот-астронавт сидит на Луне и смотрит на Землю": "提示词讲什么？例如：一只宇航员猫坐在月球上望着地球",
    "Политику и запрещённые темы не пропустим": "不接受政治和违禁话题",
    "Ваш промпт": "你的提示词",
    "Вставьте промпт, который хотите улучшить": "粘贴你想优化的提示词",
    "Название и преимущества": "名称和卖点",
    "Флисовая куртка женская на молнии Плотный мягкий флис Два боковых кармана": "女式拉链抓绒外套 厚实柔软抓绒 两侧口袋",
    "Название первой строкой, ниже по преимуществу": "第一行写名称，下面每行一个卖点",
    "Кот-астронавт": "宇航员猫",
    "Рыжий кот-астронавт сидит на Луне и смотрит на Землю": "一只橘色宇航员猫坐在月球上望着地球",
    "Город будущего": "未来城市",
    "Ночной город будущего, летающие машины и неоновые вывески": "夜晚的未来城市，飞行汽车和霓虹招牌",
    "Уютное кафе": "温馨咖啡馆",
    "Уютное кафе у окна в дождливое утро": "雨天清晨，温馨咖啡馆的窗边",
    "Горы на рассвете": "日出群山",
    "Горное озеро на рассвете, туман над водой": "日出时的高山湖泊，水面薄雾缭绕",
    "Портрет в студии": "影棚人像",
    "Студийный портрет девушки в мягком свете": "柔光下的女孩影棚人像",
    "фото": "照片",
    "видео": "视频",
    "музыки": "音乐",
    "текста": "文本",
    "Расшифровка готова": "转写稿已完成",
    "текст не создан": "文本未生成",
    "Не получилось распознать речь": "语音识别失败",
    "Получаем текст ролика": "正在获取视频文本",
    "Ролик не прошёл проверку": "视频未通过审核",
    "Не получилось получить текст": "获取文本失败",
    "Заменить ссылку": "替换链接",
    "Пишем описание товара": "正在撰写商品描述",
    "Описание не прошло проверку": "描述未通过审核",
    "описание не создано": "描述未生成",
    "Не получилось написать описание": "描述撰写失败",
    "Описание не создано": "描述未生成",
    "Фото не прошло проверку": "照片未通过审核",
    "промпт не создан": "提示词未生成",
    "Не получилось создать промпт": "提示词生成失败",
    "Промпт не создан": "提示词未生成",
    "Заменить фото": "替换照片",
    "Видео не прошло проверку": "视频未通过审核",
    "Заменить видео": "替换视频",
    "Получить текст": "获取文本",
    "Создать описание": "创建描述",
    "за текст ролика": "每条视频文本",
    "за описание": "每条描述",
    "за промпт": "每条提示词",
    "за варианты": "每组版本",
    "Фотореализм": "写实",
    "Кино": "电影",
    "Аниме": "动漫",
    "Акварель": "水彩",
    "Неон": "霓虹",
    "Минимализм": "极简",
    "3D-мультфильм": "3D 动画",
    "Документальный": "纪录片",
    "Замедление": "慢动作",
    "Эмбиент": "氛围音乐",
    "Лоу-фай": "Lo-fi",
    "Поп": "流行",
    "Оркестр": "管弦乐",
    "Синтвейв": "合成器浪潮",
    "Джаз": "爵士",
    "Деловой": "商务",
    "Ироничный": "讽刺",
    "Научный": "科普",
    "Поэтичный": "诗意",
    "Кинематографичнее": "更有电影感",
    "Свет и цвет": "光线与色彩",
    "Реализм": "写实感",
    "Движение камеры": "运镜",
    "Жанр и темп": "类型与节奏",
    "Настроение": "情绪",
    "Без вокала": "无人声",
    "Проще": "更简单",
    "Структура": "结构",
    "Тон": "语气",
    "С примером": "附示例"
  }
}
